/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  DateTime: { input: Date | string; output: string };
  Duration: { input: string; output: string };
  JSON: { input: any; output: any };
  Upload: { input: unknown; output: unknown };
};

export type AcceptInviteInput = {
  email: Scalars["String"]["input"];
  id: Scalars["Int"]["input"];
  invite: Scalars["String"]["input"];
};

export type AddClientInput = {
  email: Scalars["String"]["input"];
};

export type Address = WithDates &
  WithId & {
    __typename?: "Address";
    country?: Maybe<Scalars["String"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    id: Scalars["Int"]["output"];
    location?: Maybe<Scalars["String"]["output"]>;
    postcode?: Maybe<Scalars["String"]["output"]>;
    street?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
  };

export type AddressInput = {
  country?: InputMaybe<Scalars["String"]["input"]>;
  postcode: Scalars["String"]["input"];
  street: Scalars["String"]["input"];
};

export type AnswerInput = {
  answer: Scalars["JSON"]["input"];
  consultationUuid: Scalars["String"]["input"];
  questionId: Scalars["Int"]["input"];
};

export type Avatar = {
  __typename?: "Avatar";
  url?: Maybe<Scalars["String"]["output"]>;
};

/** This is the type for barcharts. */
export type BarchartItem = {
  __typename?: "BarchartItem";
  /** This is the key for the key-value pair. */
  name: Scalars["String"]["output"];
  /** This is the value for the key-value pair. */
  value: Scalars["Int"]["output"];
};

export type BillingInformation = WithDates &
  WithId & {
    __typename?: "BillingInformation";
    accountNumber?: Maybe<Scalars["String"]["output"]>;
    address?: Maybe<Address>;
    createdAt: Scalars["DateTime"]["output"];
    email?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["Int"]["output"];
    taxId?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
  };

export type BillingInformationInput = {
  accountNumber: Scalars["String"]["input"];
  address: AddressInput;
  notificationEmail?: InputMaybe<Scalars["String"]["input"]>;
  taxId?: InputMaybe<Scalars["String"]["input"]>;
};

export type CalendarEvent = {
  __typename?: "CalendarEvent";
  allDay: Scalars["Boolean"]["output"];
  id: Scalars["Int"]["output"];
  scheduledFrom: Scalars["DateTime"]["output"];
  scheduledTo: Scalars["DateTime"]["output"];
  type: CalendarEventTypes;
};

export type CalendarEventInput = {
  allDay: Scalars["Boolean"]["input"];
  returnAsFullCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  scheduledFrom: Scalars["DateTime"]["input"];
  scheduledTo: Scalars["DateTime"]["input"];
  type: Scalars["String"]["input"];
};

export type CalendarEventTypes =
  | "availability"
  | "consultation_appointment"
  | "consultation_intro"
  | "online"
  | "unknown_type";

export type CalendarFormats = CalendarEvent | FullCalendarEvent;

export type CanCreditsBeUsed = {
  __typename?: "CanCreditsBeUsed";
  forCoaching: Scalars["Boolean"]["output"];
  forTherapy: Scalars["Boolean"]["output"];
};

export type CancelConsultationInput = {
  /** The id of the consultation to be cancelled */
  id: Scalars["Int"]["input"];
  /** A message for the other party in the consultation */
  message?: InputMaybe<Scalars["String"]["input"]>;
};

export type CashTransaction = {
  __typename?: "CashTransaction";
  amount: Scalars["Float"]["output"];
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  mollieTransaction?: Maybe<Scalars["String"]["output"]>;
  status: CashTransactionStatusType;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

/** These are the statuses from Mollie (https://docs.mollie.com/payments/status-changes) with the addition of 'new' which we use for fresh transactions. */
export type CashTransactionStatusType =
  | "authorized"
  | "canceled"
  | "expired"
  | "failed"
  | "new"
  | "open"
  | "paid"
  | "pending"
  | "refunded";

export type ChimeAttendeeInfo = {
  __typename?: "ChimeAttendeeInfo";
  AttendeeId: Scalars["String"]["output"];
  ExternalUserId: Scalars["String"]["output"];
  JoinToken: Scalars["String"]["output"];
};

export type ChimeMediaPlacement = {
  __typename?: "ChimeMediaPlacement";
  AudioFallbackUrl: Scalars["String"]["output"];
  AudioHostUrl: Scalars["String"]["output"];
  ScreenDataUrl: Scalars["String"]["output"];
  ScreenSharingUrl: Scalars["String"]["output"];
  ScreenViewingUrl: Scalars["String"]["output"];
  SignalingUrl: Scalars["String"]["output"];
};

export type ChimeMeetingInfo = {
  __typename?: "ChimeMeetingInfo";
  ExternalMeetingId?: Maybe<Scalars["String"]["output"]>;
  MediaPlacement: ChimeMediaPlacement;
  MediaRegion: Scalars["String"]["output"];
  MeetingId: Scalars["String"]["output"];
};

export type ChoosePasswordV2Input = {
  /** A user's e-mail address */
  email: Scalars["String"]["input"];
  /** The value the password should be set to. */
  newPassword: Scalars["String"]["input"];
  /** A token that was generated by the resetPasswordV2 mutation and email */
  resetToken: Scalars["String"]["input"];
};

export type Client = {
  __typename?: "Client";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  human?: Maybe<Human>;
  humanId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  inviteToken?: Maybe<Scalars["String"]["output"]>;
  professional?: Maybe<Professional>;
  professionalId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<ClientStatus>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type ClientEdge = {
  __typename?: "ClientEdge";
  cursor?: Maybe<Scalars["String"]["output"]>;
  node?: Maybe<ClientFormats>;
};

export type ClientFormats = Client | RestrictedClient;

export type ClientStatus =
  | "CURRENT"
  | "DECLINED"
  | "INVITED"
  | "ONLY_INTRO"
  | "PAST"
  | "PENDING";

export type ClientsConnection = {
  __typename?: "ClientsConnection";
  edges?: Maybe<Array<Maybe<ClientEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CompleteHumanRegistrationInput = {
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type ConfirmConsultationInput = {
  email: Scalars["String"]["input"];
  uuid: Scalars["String"]["input"];
};

export type Consultation = {
  __typename?: "Consultation";
  acceptedByHuman?: Maybe<Scalars["Boolean"]["output"]>;
  acceptedByProfessional?: Maybe<Scalars["Boolean"]["output"]>;
  bloomupFee?: Maybe<Scalars["Float"]["output"]>;
  cashTransaction?: Maybe<CashTransaction>;
  createdAt: Scalars["Date"]["output"];
  creditTransactions: Array<CreditTransaction>;
  duration: Scalars["Duration"]["output"];
  expectedReimbursementDate?: Maybe<Scalars["Date"]["output"]>;
  fromMatching: Scalars["Boolean"]["output"];
  human?: Maybe<Human>;
  humanId?: Maybe<Scalars["Int"]["output"]>;
  id: Scalars["Int"]["output"];
  isInstant?: Maybe<Scalars["Boolean"]["output"]>;
  matchedHuman?: Maybe<MatchedHuman>;
  message?: Maybe<Message>;
  professional?: Maybe<Professional>;
  professionalFee?: Maybe<Scalars["Float"]["output"]>;
  professionalId?: Maybe<Scalars["Int"]["output"]>;
  requestedBy?: Maybe<RequestedByType>;
  scheduledFrom: Scalars["DateTime"]["output"];
  scheduledTo: Scalars["DateTime"]["output"];
  status: ConsultationStatus;
  type?: Maybe<ConsultationType>;
  updatedAt: Scalars["Date"]["output"];
  uuid: Scalars["String"]["output"];
};

export type ConsultationEdge = {
  __typename?: "ConsultationEdge";
  cursor?: Maybe<Scalars["String"]["output"]>;
  node: Consultation;
};

export type ConsultationFilter = {
  status?: InputMaybe<Array<ConsultationStatus>>;
};

export type ConsultationStatus =
  | "ACCEPTED"
  | "CANCELLED"
  | "CANCELLED_BY_HUMAN"
  | "CANCELLED_BY_PROFESSIONAL"
  | "DONE"
  | "IN_PROGRESS"
  | "NO_SHOW_HUMAN"
  | "NO_SHOW_PROFESSIONAL"
  | "REQUESTED"
  | "WAITING";

export type ConsultationType = "APPOINTMENT" | "CHECKIN" | "COACHING" | "INTRO";

export type ConsultationsConnection = {
  __typename?: "ConsultationsConnection";
  edges: Array<ConsultationEdge>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CopyCalendarEventsInput = {
  copyTo: Scalars["DateTime"]["input"];
  from: Scalars["DateTime"]["input"];
  onlyType?: InputMaybe<Scalars["String"]["input"]>;
  returnAsFullCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  to: Scalars["DateTime"]["input"];
};

export type Country = {
  __typename?: "Country";
  descriptionTranslationKey: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  imgUrl: Scalars["String"]["output"];
  regions?: Maybe<Array<Region>>;
  titleTranslationKey: Scalars["String"]["output"];
};

export type CreateConsultationInput = {
  fromMatching: Scalars["Boolean"]["input"];
  matchedHumanId?: InputMaybe<Scalars["Int"]["input"]>;
  otherPartyId: Scalars["Int"]["input"];
  price?: InputMaybe<Scalars["Float"]["input"]>;
  scheduledFrom: Scalars["DateTime"]["input"];
  scheduledTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<Scalars["String"]["input"]>;
  type: ConsultationType;
};

export type CreditTransaction = {
  __typename?: "CreditTransaction";
  amount: Scalars["Float"]["output"];
  id: Scalars["Int"]["output"];
};

export type DeleteCalendarEventsInput = {
  ids: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

/** This is the type for well being gauge charts. */
export type DifferenceGaugeResult = {
  __typename?: "DifferenceGaugeResult";
  /** This is the average first score. */
  averageFirstScore: Scalars["Float"]["output"];
  /** This is the average improvement. */
  averageImprovement: Scalars["Float"]["output"];
  /** This is the average latest score. */
  averageLatestScore: Scalars["Float"]["output"];
};

export type Enable2FaInput = {
  secret: Scalars["String"]["input"];
  token: Scalars["String"]["input"];
};

export type EntryPoints =
  | "after_consultation"
  | "after_intro"
  | "after_last_planned_consultation"
  | "before_consultation"
  | "during_self_help"
  | "end_of_treatment"
  | "in_app_notification";

export type EntryPointsInput = {
  entrypoint: EntryPoints;
};

export type ExtendedProps = {
  __typename?: "ExtendedProps";
  status?: Maybe<Scalars["String"]["output"]>;
  type: CalendarEventTypes;
};

export type FullCalendarEvent = {
  __typename?: "FullCalendarEvent";
  allDay: Scalars["Boolean"]["output"];
  end: Scalars["DateTime"]["output"];
  extendedProps: ExtendedProps;
  id: Scalars["String"]["output"];
  start: Scalars["DateTime"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

/** This is the type for funnelcharts. */
export type FunnelItem = {
  __typename?: "FunnelItem";
  /** This is the key for the key-value pair. */
  name: Scalars["String"]["output"];
  /** This is the value for the key-value pair. */
  value: Scalars["Int"]["output"];
};

/** The persona of an individual human/client on the platform. Reference attached user for persona agnostic fields */
export type Human = WithId & {
  __typename?: "Human";
  address?: Maybe<Address>;
  /** @deprecated Prefer to access on user object */
  birthDate?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * If this is true human can pay for their coaching with credits this is true. e.g. still credits left
   * When false it means the user has to pay for coaching themselves.
   * @deprecated Prefer to use creditBalance object
   */
  canPayCoachingWithCredits: Scalars["Boolean"]["output"];
  /**
   * If this is true human can pay for their consult with credits this is true. e.g. still credits left
   * When false it means the user has to pay for scheduled consult themselves.
   * @deprecated Prefer to use creditBalance object
   */
  canPayConsultWithCredits: Scalars["Boolean"]["output"];
  /**
   * If this is true human can pay for their consultations with credits this is true. e.g. still credits left
   * When false it means the user has to pay for scheduled consultations themselves.
   * @deprecated Prefer to use creditBalance object
   */
  canPayWithCredits: Scalars["Boolean"]["output"];
  contactForFeedback: Scalars["Boolean"]["output"];
  country?: Maybe<Country>;
  createdAt: Scalars["DateTime"]["output"];
  /** Returns null if the user is not linked to an org, doesn't have a currentContract or is not allowed to use credits. Otherwise it returns an object with multiple numbers */
  creditBalance?: Maybe<HumanCreditBalance>;
  /**
   * If the user is attached to a organization that specifies a maximum credits per human value, this returns the remaining amount for this user in the contract period.
   * Returns null when this value doesn't exist because current contract doesn't limit individual usage. If no org or no contract this returns 0;
   * @deprecated Prefer to use creditBalance object
   */
  creditsLeft?: Maybe<Scalars["Float"]["output"]>;
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Prefer to access on user object */
  email: Scalars["String"]["output"];
  /** @deprecated Prefer to access on user object */
  firstName?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  /** @deprecated Prefer to access on user object */
  lastName?: Maybe<Scalars["String"]["output"]>;
  mutuality?: Maybe<Mutuality>;
  onboardedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /**
   * The organization this human is a member of.
   * This will return null if the user is not linked to an organization with a current contract.
   */
  organization?: Maybe<Organization>;
  /** @deprecated Prefer to access on the organization object */
  organizationId?: Maybe<Scalars["Int"]["output"]>;
  password?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Prefer to access on user object */
  phone?: Maybe<Scalars["String"]["output"]>;
  /**
   * The preferred language for this user. He / she will see all text presented in this language.
   * This is also the language that will be the default language used in consultations.
   * @deprecated Prefer to access on user object
   */
  preferredLanguage: Language;
  preferredProfessionalGender?: Maybe<Scalars["String"]["output"]>;
  region?: Maybe<Region>;
  /** @deprecated Prefer to access on user object */
  timezone: Scalars["String"]["output"];
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The user account for this human */
  user: User;
  /** @deprecated Prefer to access on user object */
  uuid: Scalars["String"]["output"];
};

export type HumanCreditBalance = {
  __typename?: "HumanCreditBalance";
  remainingCoachingConsultations?: Maybe<Scalars["Int"]["output"]>;
  remainingTherapyConsultations?: Maybe<Scalars["Int"]["output"]>;
  total?: Maybe<Scalars["Float"]["output"]>;
};

export type HumanWithTokens = {
  __typename?: "HumanWithTokens";
  accessToken: Scalars["String"]["output"];
  human?: Maybe<Human>;
  refreshToken: Scalars["String"]["output"];
};

export type Language = "en" | "fr" | "frBe" | "nl" | "nlBe";

/** This is the type for line graphs. */
export type LineGraphItem = {
  __typename?: "LineGraphItem";
  /** This is the x value for the line chart. */
  x: Scalars["String"]["output"];
  /** This is the y value for the line chart. */
  y: Scalars["Int"]["output"];
};

export type LoginFailureReason =
  | "INCORRECT_2FA"
  | "INCORRECT_CREDENTIALS"
  | "NEEDS_2FA";

export type LoginV2FailureResponse = {
  __typename?: "LoginV2FailureResponse";
  /** The reason here is a value from an enum that indicates the reason why why the login failed. */
  reason: LoginFailureReason;
};

export type LoginV2Input = {
  email: Scalars["String"]["input"];
  password: Scalars["String"]["input"];
  token2FA?: InputMaybe<Scalars["String"]["input"]>;
};

export type LoginV2Response = LoginV2FailureResponse | TokenResponse;

export type LoginWithSsoInput = {
  authorizationCode: Scalars["String"]["input"];
  mindlabBusinessId?: InputMaybe<Scalars["String"]["input"]>;
  redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type MatchedHuman = {
  __typename?: "MatchedHuman";
  age?: Maybe<Scalars["Int"]["output"]>;
  chosenProfessionalId?: Maybe<Scalars["Int"]["output"]>;
  country?: Maybe<Country>;
  createdAt: Scalars["Date"]["output"];
  human?: Maybe<Human>;
  id: Scalars["Int"]["output"];
  matchConsultation?: Maybe<Consultation>;
  mutuality?: Maybe<Mutuality>;
  mutualityOptions: MutualitiesResponse;
  noLocation: Scalars["Boolean"]["output"];
  noMutuality: Scalars["Boolean"]["output"];
  noSubtopic: Scalars["Boolean"]["output"];
  noTopic: Scalars["Boolean"]["output"];
  organization?: Maybe<Organization>;
  preferredProfessionalGender?: Maybe<Scalars["String"]["output"]>;
  proposedMatches: Array<Professional>;
  region?: Maybe<Region>;
  subtopic?: Maybe<Subtopic>;
  topic?: Maybe<Topic>;
  treatment?: Maybe<Treatment>;
  treatmentOptions: TreatmentsResponse;
  updatedAt: Scalars["Date"]["output"];
  userUuid?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated We dont use this anymore, since april 2021 */
  worries?: Maybe<Scalars["String"]["output"]>;
};

export type Message = {
  __typename?: "Message";
  body?: Maybe<Scalars["String"]["output"]>;
  consultationId?: Maybe<Scalars["Int"]["output"]>;
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  fromProfessional?: Maybe<Scalars["Boolean"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type MessageInput = {
  body?: InputMaybe<Scalars["String"]["input"]>;
  fromProfessional?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Module = {
  __typename?: "Module";
  id: Scalars["String"]["output"];
  title: MultiLanguageString;
  url: Scalars["String"]["output"];
};

export type MultiLanguageString = {
  __typename?: "MultiLanguageString";
  en?: Maybe<Scalars["String"]["output"]>;
  fr?: Maybe<Scalars["String"]["output"]>;
  nl?: Maybe<Scalars["String"]["output"]>;
};

/** MUTATIONS */
export type Mutation = {
  __typename?: "Mutation";
  acceptInvite?: Maybe<Client>;
  answerQuestion?: Maybe<Scalars["Boolean"]["output"]>;
  /** Cancels the specified consultation and notififies relevant parties */
  cancelConsultation: Consultation;
  /** Sets a new password for an existing user based off email and token, returns true when password was set successfully */
  choosePasswordV2: Scalars["Boolean"]["output"];
  /**
   * Registers more info for a new Human and returns the new entity. For this to happen,
   * The user should have logged in (so a token is present)
   */
  completeHumanRegistration?: Maybe<Human>;
  confirmConsultation?: Maybe<Consultation>;
  copyCalendarEvents?: Maybe<Array<Maybe<CalendarFormats>>>;
  createCalendarEvent?: Maybe<CalendarFormats>;
  createConsultation?: Maybe<Consultation>;
  deleteCalendarEvents?: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  /** Mutation to enable 2FA. Input should be a secret and a token. The response will be a boolean indicating whether te enabling succeeded. */
  enable2FA: Scalars["Boolean"]["output"];
  inviteClient?: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * Adds the currently logged in user to the organization specified by the input email address, or code.
   * Uses the same matching rules as the `organizationByEmailOrCode` query
   */
  joinOrganizationByEmailOrCodeV2?: Maybe<Scalars["Boolean"]["output"]>;
  /** Mutation to handle a login. Input should be a user's email, password and 2fa token, the response will either be a jwt token or a failure code */
  loginV2: LoginV2Response;
  /** Mutation to log a user in using an SSO authorization code */
  loginWithSSO: LoginV2Response;
  payForConsultation?: Maybe<Scalars["String"]["output"]>;
  /** Query to refresh a user's tokens. Input should be the user's refreshToken. Response will be a new accessToken, new refreshToken and new mindLabToken */
  refreshAccessTokenV2: TokenResponse;
  /** Creates a new Human and returns access tokens for the associated user. */
  registerHumanV2: TokenResponse;
  /**
   * Registers more info for a new Human and returns the new entity. For this to happen,
   * the user needs to be invited by a professional, and should have an invite token present in the
   * url.
   */
  registerHumanWithInvite?: Maybe<HumanWithTokens>;
  /** Registers a Professional */
  registerProfessional?: Maybe<Scalars["Boolean"]["output"]>;
  /** Mutation to request the secrets to set up 2FA. Input should be a secret and a qrcode. The response are the secrets needed to setup 2fa. */
  request2FASecrets: Secrets2Fa;
  requestConsultationAsHuman: Consultation;
  requestIntroAsHuman: Consultation;
  /** Creates reimbursement information */
  requestReimbursement?: Maybe<Reimbursement>;
  rescheduleConsultation: Consultation;
  /** Mutation to reset a user's password. Input should be a user's email. The response is a boolean indicating whether the reset process has been started. */
  resetPassword: Scalars["Boolean"]["output"];
  /** Updates the language for the currently logged in user. Will only work when authenticated. */
  setCurrentUserLanguage: User;
  startMatchingV2: SubmitMatchingStepResponse;
  startVideoCallV2?: Maybe<VideoCallV2>;
  submitLocationStep: SubmitMatchingStepResponse;
  submitMutualityStep: SubmitMatchingStepResponse;
  submitSubtopicStep: SubmitMatchingStepResponse;
  submitTopicStep: SubmitMatchingStepResponse;
  submitTreatmentStep: SubmitMatchingStepResponse;
  toggleCoachingEnabledForProfessional: Professional;
  toggleTherapyEnabledForProfessional: Professional;
  updateCalendarEvent?: Maybe<CalendarFormats>;
  updateConsultation?: Maybe<Consultation>;
  /** Updates the current user */
  updateCurrentUser: User;
  /** Updates a Human and returns the updated entity. */
  updateHuman?: Maybe<Human>;
  /** Links the human to a mutuality */
  updateHumanMutuality?: Maybe<Human>;
  updateMatchedHumanLanguage: MatchedHuman;
  /** Updates a Professional and returns the updated entity */
  updateProfessional?: Maybe<Professional>;
  updateProfessionalRate: Professional;
  /** Updates the specialties of a Professional and returns the adjusted professional. */
  updateProfessionalSpecialties?: Maybe<Professional>;
  updateProfessionalSubtopics: Professional;
  userJoinedConsultation: Consultation;
  /** Sets a Professionals status to verified and returns the updated entity */
  verifyProfessional: Professional;
};

/** MUTATIONS */
export type MutationAcceptInviteArgs = {
  input: AcceptInviteInput;
};

/** MUTATIONS */
export type MutationAnswerQuestionArgs = {
  input: AnswerInput;
};

/** MUTATIONS */
export type MutationCancelConsultationArgs = {
  input: CancelConsultationInput;
};

/** MUTATIONS */
export type MutationChoosePasswordV2Args = {
  input: ChoosePasswordV2Input;
};

/** MUTATIONS */
export type MutationCompleteHumanRegistrationArgs = {
  input: CompleteHumanRegistrationInput;
};

/** MUTATIONS */
export type MutationConfirmConsultationArgs = {
  input: ConfirmConsultationInput;
};

/** MUTATIONS */
export type MutationCopyCalendarEventsArgs = {
  input: CopyCalendarEventsInput;
};

/** MUTATIONS */
export type MutationCreateCalendarEventArgs = {
  input: CalendarEventInput;
};

/** MUTATIONS */
export type MutationCreateConsultationArgs = {
  input: CreateConsultationInput;
};

/** MUTATIONS */
export type MutationDeleteCalendarEventsArgs = {
  input: DeleteCalendarEventsInput;
};

/** MUTATIONS */
export type MutationEnable2FaArgs = {
  input: Enable2FaInput;
};

/** MUTATIONS */
export type MutationInviteClientArgs = {
  input: AddClientInput;
};

/** MUTATIONS */
export type MutationJoinOrganizationByEmailOrCodeV2Args = {
  emailOrCode: Scalars["String"]["input"];
};

/** MUTATIONS */
export type MutationLoginV2Args = {
  input: LoginV2Input;
};

/** MUTATIONS */
export type MutationLoginWithSsoArgs = {
  input: LoginWithSsoInput;
};

/** MUTATIONS */
export type MutationPayForConsultationArgs = {
  input: PaymentInput;
};

/** MUTATIONS */
export type MutationRefreshAccessTokenV2Args = {
  refreshToken: Scalars["String"]["input"];
};

/** MUTATIONS */
export type MutationRegisterHumanV2Args = {
  input: RegisterHumanInput;
};

/** MUTATIONS */
export type MutationRegisterHumanWithInviteArgs = {
  input: RegisterHumanWithInviteInput;
  inviteToken: Scalars["String"]["input"];
};

/** MUTATIONS */
export type MutationRegisterProfessionalArgs = {
  input: ProfessionalRegistrationInput;
};

/** MUTATIONS */
export type MutationRequest2FaSecretsArgs = {
  password: Scalars["String"]["input"];
};

/** MUTATIONS */
export type MutationRequestConsultationAsHumanArgs = {
  input: RequestConsultationAsHumanInput;
};

/** MUTATIONS */
export type MutationRequestIntroAsHumanArgs = {
  input: RequestIntroAsHumanInput;
};

/** MUTATIONS */
export type MutationRequestReimbursementArgs = {
  input: ReimbursementInput;
};

/** MUTATIONS */
export type MutationRescheduleConsultationArgs = {
  input: RescheduleConsultationInput;
};

/** MUTATIONS */
export type MutationResetPasswordArgs = {
  email: Scalars["String"]["input"];
  fromMindlab?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** MUTATIONS */
export type MutationSetCurrentUserLanguageArgs = {
  language: Language;
};

/** MUTATIONS */
export type MutationStartMatchingV2Args = {
  input: StartMatchingV2Input;
};

/** MUTATIONS */
export type MutationStartVideoCallV2Args = {
  consultationUuid: Scalars["String"]["input"];
};

/** MUTATIONS */
export type MutationSubmitLocationStepArgs = {
  input: SubmitLocationStepInput;
};

/** MUTATIONS */
export type MutationSubmitMutualityStepArgs = {
  mutualityId?: InputMaybe<Scalars["String"]["input"]>;
};

/** MUTATIONS */
export type MutationSubmitSubtopicStepArgs = {
  subtopicId?: InputMaybe<Scalars["String"]["input"]>;
};

/** MUTATIONS */
export type MutationSubmitTopicStepArgs = {
  topicId?: InputMaybe<Scalars["String"]["input"]>;
};

/** MUTATIONS */
export type MutationSubmitTreatmentStepArgs = {
  treatment: Treatment;
};

/** MUTATIONS */
export type MutationToggleCoachingEnabledForProfessionalArgs = {
  input: Scalars["Boolean"]["input"];
};

/** MUTATIONS */
export type MutationToggleTherapyEnabledForProfessionalArgs = {
  input: Scalars["Boolean"]["input"];
};

/** MUTATIONS */
export type MutationUpdateCalendarEventArgs = {
  input: UpdateCalendarEventInput;
};

/** MUTATIONS */
export type MutationUpdateConsultationArgs = {
  input: UpdateConsultationInput;
};

/** MUTATIONS */
export type MutationUpdateCurrentUserArgs = {
  input: UpdateCurrentUserInput;
};

/** MUTATIONS */
export type MutationUpdateHumanArgs = {
  input: UpdateHumanInput;
};

/** MUTATIONS */
export type MutationUpdateHumanMutualityArgs = {
  mutualityId?: InputMaybe<Scalars["String"]["input"]>;
};

/** MUTATIONS */
export type MutationUpdateMatchedHumanLanguageArgs = {
  language: Language;
};

/** MUTATIONS */
export type MutationUpdateProfessionalArgs = {
  input: ProfessionalInput;
};

/** MUTATIONS */
export type MutationUpdateProfessionalRateArgs = {
  input: UpdateProfessionalRateInput;
};

/** MUTATIONS */
export type MutationUpdateProfessionalSpecialtiesArgs = {
  input: ProfessionalSpecialtiesInput;
};

/** MUTATIONS */
export type MutationUpdateProfessionalSubtopicsArgs = {
  input: UpdateProfessionalSubtopicsInput;
};

/** MUTATIONS */
export type MutationUserJoinedConsultationArgs = {
  consultationId: Scalars["Int"]["input"];
};

/** MUTATIONS */
export type MutationVerifyProfessionalArgs = {
  id: Scalars["Int"]["input"];
};

export type MutualitiesResponse = {
  __typename?: "MutualitiesResponse";
  otherMutualities: Array<Mutuality>;
  regionMutualities: Array<Mutuality>;
};

export type Mutuality = {
  __typename?: "Mutuality";
  descriptionTranslationKey?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
  imgUrl: Scalars["String"]["output"];
  linkUrlTranslationKey: Scalars["String"]["output"];
  preferred: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
};

export type MutualityFilter = {
  preferred?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Organization = {
  __typename?: "Organization";
  canCreditsBeUsed?: Maybe<CanCreditsBeUsed>;
  coachingEnabled: Scalars["Boolean"]["output"];
  coachingsPerHuman?: Maybe<Scalars["Int"]["output"]>;
  code?: Maybe<Scalars["String"]["output"]>;
  color?: Maybe<Scalars["String"]["output"]>;
  consultsPerHuman?: Maybe<Scalars["Int"]["output"]>;
  contractDashboardUrl?: Maybe<MultiLanguageString>;
  /** Returns the end date of the current contract, if no current contract it returns null */
  contractEndDate?: Maybe<Scalars["Date"]["output"]>;
  /** Returns the start date of the current contract, if no current contract it returns null */
  contractStartDate?: Maybe<Scalars["Date"]["output"]>;
  /** Returns the number of credits required for a coaching session in the current contract */
  creditsPerCoaching?: Maybe<Scalars["Float"]["output"]>;
  /** Returns the number of credits required for a consultation session in the current contract */
  creditsPerConsult?: Maybe<Scalars["Float"]["output"]>;
  creditsPerHuman?: Maybe<Scalars["Int"]["output"]>;
  /** Returns true if there is a contract in the database that starts after the current contract has ended */
  hasRenewalContract: Scalars["Boolean"]["output"];
  id: Scalars["Int"]["output"];
  interestDashboardUrl?: Maybe<MultiLanguageString>;
  logoUrl: MultiLanguageString;
  mentalWellbeingDashboardUrl?: Maybe<MultiLanguageString>;
  mindlabBusinessId?: Maybe<Scalars["String"]["output"]>;
  /** Whether this organization currently has access to mindlab */
  mindlabEnabled: Scalars["Boolean"]["output"];
  name: MultiLanguageString;
  pobosEnabled: Scalars["Boolean"]["output"];
  /** Markdown formatted information about this organization to show professionals */
  profile: MultiLanguageString;
  slug: Scalars["String"]["output"];
  ssoEnabled: Scalars["Boolean"]["output"];
  testsEnabled: Scalars["Boolean"]["output"];
  usageDashboardUrl?: Maybe<MultiLanguageString>;
  videoEnabled: Scalars["Boolean"]["output"];
};

export type PageInfo = {
  __typename?: "PageInfo";
  endCursor?: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
  hasPreviousPage: Scalars["Boolean"]["output"];
  startCursor?: Maybe<Scalars["String"]["output"]>;
};

export type PaymentInput = {
  cashTransactionId: Scalars["Int"]["input"];
};

export type Practice = WithDates &
  WithId & {
    __typename?: "Practice";
    address?: Maybe<Address>;
    chatTherapy?: Maybe<Scalars["Boolean"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    id: Scalars["Int"]["output"];
    offlineTherapy?: Maybe<Scalars["Boolean"]["output"]>;
    onlineTherapy?: Maybe<Scalars["Boolean"]["output"]>;
    phoneTherapy?: Maybe<Scalars["Boolean"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
  };

export type PracticeInput = {
  address?: InputMaybe<AddressInput>;
  chatTherapy?: InputMaybe<Scalars["Boolean"]["input"]>;
  offlineTherapy?: InputMaybe<Scalars["Boolean"]["input"]>;
  onlineTherapy?: InputMaybe<Scalars["Boolean"]["input"]>;
  phoneTherapy?: InputMaybe<Scalars["Boolean"]["input"]>;
};

/** The persona of an individual professional on the platform. Reference attached user for persona agnostic fields */
export type Professional = WithId & {
  __typename?: "Professional";
  /** @deprecated Prefer to use availabilityV2 */
  availability?: Maybe<Array<Scalars["String"]["output"]>>;
  availabilityV2: Array<Scalars["DateTime"]["output"]>;
  /** Link to an avatar image */
  avatar?: Maybe<Avatar>;
  billingInformation?: Maybe<BillingInformation>;
  /** @deprecated Prefer to access on user object */
  birthDate?: Maybe<Scalars["DateTime"]["output"]>;
  clientStop?: Maybe<Scalars["Boolean"]["output"]>;
  /** Clients are humans that are linked to this professional */
  clients: ProfessionalHumanConnection;
  cmNumber?: Maybe<Scalars["String"]["output"]>;
  coachingEnabled: Scalars["Boolean"]["output"];
  coachingRate?: Maybe<Scalars["Float"]["output"]>;
  consultationLanguages: Array<Maybe<Scalars["String"]["output"]>>;
  createdAt: Scalars["DateTime"]["output"];
  deletedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Prefer to access on user object */
  email: Scalars["String"]["output"];
  /** Experience of this professional in years. */
  experienceSince?: Maybe<Scalars["DateTime"]["output"]>;
  /** @deprecated Prefer to access on user object */
  firstName?: Maybe<Scalars["String"]["output"]>;
  gender?: Maybe<Scalars["String"]["output"]>;
  id: Scalars["Int"]["output"];
  /** Whether or not this professional is a 'firstline' professional. */
  isFirstLine?: Maybe<Scalars["Boolean"]["output"]>;
  isOnline: Scalars["Boolean"]["output"];
  /** @deprecated Prefer to access on user object */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /**
   * Files that are linked to this professional
   * #TODO: Add File type
   */
  licenseFiles?: Maybe<Array<Maybe<UserFile>>>;
  onboardedAt?: Maybe<Scalars["DateTime"]["output"]>;
  organizationId?: Maybe<Scalars["Int"]["output"]>;
  /** @deprecated Prefer to access on user object */
  phone?: Maybe<Scalars["String"]["output"]>;
  practice?: Maybe<Practice>;
  /**
   * The preferred language for this user. He / she will see all text presented in this language.
   * This is also the language that will be the default language used in consultations.
   * @deprecated Prefer to access on user object
   */
  preferredLanguage: Language;
  primarySubtopics: Array<Subtopic>;
  /**
   * Short text in which the professional describes him/herself. JSON string that must be parsed.
   * @deprecated Replaced by profileDescription
   */
  profile?: Maybe<Scalars["String"]["output"]>;
  /** Short text in which the professional describes him/herself. */
  profileDescription: MultiLanguageString;
  roleType?: Maybe<Scalars["String"]["output"]>;
  secondarySubtopics: Array<Subtopic>;
  /** An array containing a professional's specialities. */
  specialties: Array<Maybe<SpecialtiesThemeCombo>>;
  /** Rate a professional charges per hour. */
  standardRate?: Maybe<Scalars["Float"]["output"]>;
  /** Whether or not this professional offers supervision. */
  supervision?: Maybe<Scalars["Boolean"]["output"]>;
  therapyEnabled: Scalars["Boolean"]["output"];
  /** Types of therapy that are offered by this professional. */
  therapyTypes?: Maybe<Scalars["String"]["output"]>;
  /** @deprecated Prefer to access on user object */
  timezone: Scalars["String"]["output"];
  /** The training this professional has had. */
  training?: Maybe<Scalars["String"]["output"]>;
  /** The type of this professional. */
  type?: Maybe<Scalars["String"]["output"]>;
  updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** The user account for this professional */
  user: User;
  /** @deprecated Prefer to access on user object */
  uuid: Scalars["String"]["output"];
  /** Date and time at which this professional was verified by the BloomUp Team. */
  verifiedAt?: Maybe<Scalars["DateTime"]["output"]>;
  visumNumber?: Maybe<Scalars["String"]["output"]>;
  /** This professional's website. */
  website?: Maybe<Scalars["String"]["output"]>;
};

/** The persona of an individual professional on the platform. Reference attached user for persona agnostic fields */
export type ProfessionalAvailabilityArgs = {
  timeInMinutes?: InputMaybe<Scalars["Int"]["input"]>;
};

/** The persona of an individual professional on the platform. Reference attached user for persona agnostic fields */
export type ProfessionalAvailabilityV2Args = {
  amountOfDaysInTheFuture?: InputMaybe<Scalars["Int"]["input"]>;
  consultationType: ConsultationType;
};

export type ProfessionalEdge = {
  __typename?: "ProfessionalEdge";
  cursor?: Maybe<Scalars["String"]["output"]>;
  node?: Maybe<Professional>;
};

/** The connection type between a human and a professional */
export type ProfessionalHumanConnection = {
  __typename?: "ProfessionalHumanConnection";
  edges: Array<ProfessionalHumanEdge>;
};

/** The connection edge between a human and a professional */
export type ProfessionalHumanEdge = {
  __typename?: "ProfessionalHumanEdge";
  node: Human;
};

export type ProfessionalInput = {
  acceptedConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  avatar?: InputMaybe<Scalars["Upload"]["input"]>;
  billingInformation?: InputMaybe<BillingInformationInput>;
  birthDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  clientStop?: InputMaybe<Scalars["Boolean"]["input"]>;
  cmNumber?: InputMaybe<Scalars["String"]["input"]>;
  consultationLanguages?: InputMaybe<Scalars["String"]["input"]>;
  country?: InputMaybe<Scalars["String"]["input"]>;
  deletedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  experienceSince?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  isFirstLine?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  licenseFiles?: InputMaybe<Array<Scalars["Upload"]["input"]>>;
  onboardedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  practice?: InputMaybe<PracticeInput>;
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>;
  profile?: InputMaybe<Scalars["String"]["input"]>;
  specialties?: InputMaybe<Scalars["String"]["input"]>;
  standardRate?: InputMaybe<Scalars["Float"]["input"]>;
  supervision?: InputMaybe<Scalars["Boolean"]["input"]>;
  therapyTypes?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  training?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  visumNumber?: InputMaybe<Scalars["String"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfessionalRegistrationInput = {
  acceptedConsent?: InputMaybe<Scalars["Boolean"]["input"]>;
  consultationLanguages?: InputMaybe<Scalars["String"]["input"]>;
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  gender?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  licenseFiles?: InputMaybe<Array<Scalars["Upload"]["input"]>>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
  training?: InputMaybe<Scalars["String"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
  website?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProfessionalSpecialtiesInput = {
  /** Specialties should be an array of uuids of SpecialtiesThemeCombo's */
  specialtiesThemeComboIds: Array<Scalars["String"]["input"]>;
};

export type ProfessionalsConnection = {
  __typename?: "ProfessionalsConnection";
  edges?: Maybe<Array<Maybe<ProfessionalEdge>>>;
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars["Int"]["output"]>;
};

export type ProfessionalsForCurrentHumanInput = {
  withAvailability?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ProfessionalsInput = {
  adminsIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
  adminsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  verifiedIncluded?: InputMaybe<Scalars["Boolean"]["input"]>;
  verifiedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type Query = {
  __typename?: "Query";
  allConsultationsForHuman?: Maybe<ConsultationsConnection>;
  allConsultationsForProfessional?: Maybe<ConsultationsConnection>;
  calendarEvents?: Maybe<Array<Maybe<CalendarFormats>>>;
  cashTransactionsByConsultationId?: Maybe<Array<Maybe<CashTransaction>>>;
  clientsForProfessional?: Maybe<ClientsConnection>;
  consultation?: Maybe<Consultation>;
  /** Returns the list of consultations that the logged in human has with the specified professional */
  consultationsForProfessionalAndHuman?: Maybe<ConsultationsConnection>;
  countries: Array<Country>;
  currentMatchedHuman?: Maybe<MatchedHuman>;
  /** Returns the currently logged in user. If tokens are invalid or not provided this will return null */
  currentUser?: Maybe<User>;
  getQuestionById?: Maybe<Question>;
  getSSOUrl: Scalars["String"]["output"];
  /** Returns a patient with the specified Id */
  human?: Maybe<Human>;
  /**
   * This query returns the slug of a given org id.
   * If the org id is missing, global data will be returned.
   */
  landingPageUniqueVisitors: Array<LineGraphItem>;
  lastCashTransactionByConsultationId?: Maybe<CashTransaction>;
  mindlabUser?: Maybe<User>;
  mindlabUsers?: Maybe<Array<Maybe<User>>>;
  /** Returns all mutualities */
  mutualities: Array<Mutuality>;
  /** Returns a list of consultations for the logged in professionals with optional pagination and filtering */
  myProfessionalConsultations: ConsultationsConnection;
  /** Verifies if the provided code is linked to an organisation, or if the arg is an email, if it's domain matches an organisation */
  organizationByEmailOrCode?: Maybe<Organization>;
  organizationById?: Maybe<Organization>;
  organizations?: Maybe<Array<Maybe<Organization>>>;
  /**
   * Returns a professional with the specified Id, if no id is specified, returns the currently logged in
   * professional
   */
  professional?: Maybe<Professional>;
  professionalExists?: Maybe<Scalars["Boolean"]["output"]>;
  /** Returns all professionals */
  professionals?: Maybe<ProfessionalsConnection>;
  /** Returns all professionals for a logged in human */
  professionalsForCurrentHuman?: Maybe<ProfessionalsConnection>;
  professionalsV2?: Maybe<ProfessionalsConnection>;
  questionForUserAtEntryPoint?: Maybe<Question>;
  specialties?: Maybe<Array<Maybe<SpecialtiesThemeCombo>>>;
  subtopics: Array<Subtopic>;
  topics: Array<Topic>;
  /**
   * This query returns the total of employees with an n amount of consults.
   * e.g.: 10 employees with 1 consult, 5 employees with 2 consults, etc.
   * If the org id is missing, global data will be returned.
   */
  videoConsultBarchartEmployeesWithAnAmountOfConsults: Array<BarchartItem>;
  /**
   * This query returns the average consult per employee.
   * If the org id is missing, global data will be returned.
   */
  videoConsultCardAverageConsultPerEmployee: Scalars["Float"]["output"];
  /**
   * This query returns consults that have been canceled.
   * If the org id is missing, global data will be returned.
   */
  videoConsultCardCancelledConsults: Scalars["Int"]["output"];
  /**
   * This query returns consults that have been completed.
   * If the org id is missing, global data will be returned.
   */
  videoConsultCardCompletedConsults: Scalars["Int"]["output"];
  /**
   * This query returns consults that have been canceled.
   * If the org id is missing, global data will be returned.
   */
  videoConsultCardNoShowConsults: Scalars["Int"]["output"];
  /**
   * This query returns a name and a value for the funnel chart.
   * If the org id is missing, global data will be returned.
   */
  videoConsultFunnel: Array<FunnelItem>;
  /**
   * This query returns the wellbeing challenges list
   * ordered from most chosen challenge to least chosen challenge, limited to 10.
   * If the org id is missing, global data will be returned.
   */
  wellbeingChallenges: Array<WellbeingChallengesResult>;
  /**
   * This query returns the wellbeing value(s) for the energy gauge chart.
   * If the org id is missing, global data will be returned.
   */
  wellbeingEnergyGauge: DifferenceGaugeResult;
  /**
   * This query returns the wellbeing value(s) for the productivity gauge chart.
   * If the org id is missing, global data will be returned.
   */
  wellbeingProductivityGauge: DifferenceGaugeResult;
  /**
   * This query returns the wellbeing value(s) for the stress gauge chart.
   * If the org id is missing, global data will be returned.
   */
  wellbeingStressGauge: DifferenceGaugeResult;
};

export type QueryCalendarEventsArgs = {
  asFullCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type QueryCashTransactionsByConsultationIdArgs = {
  consultationId: Scalars["Int"]["input"];
};

export type QueryConsultationArgs = {
  uuid: Scalars["String"]["input"];
};

export type QueryConsultationsForProfessionalAndHumanArgs = {
  humanId: Scalars["Int"]["input"];
};

export type QueryGetQuestionByIdArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryGetSsoUrlArgs = {
  mindlabBusinessId?: InputMaybe<Scalars["String"]["input"]>;
  redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryHumanArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryLandingPageUniqueVisitorsArgs = {
  endDate: Scalars["Date"]["input"];
  organizationID: Scalars["Int"]["input"];
  startDate: Scalars["Date"]["input"];
};

export type QueryLastCashTransactionByConsultationIdArgs = {
  consultationId: Scalars["Int"]["input"];
};

export type QueryMindlabUserArgs = {
  mindlabUserId: Scalars["String"]["input"];
};

export type QueryMindlabUsersArgs = {
  mindlabUserIds: Array<Scalars["String"]["input"]>;
};

export type QueryMutualitiesArgs = {
  filter?: InputMaybe<MutualityFilter>;
};

export type QueryMyProfessionalConsultationsArgs = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  filter?: InputMaybe<ConsultationFilter>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  order?: InputMaybe<ConsultationOrder>;
};

export type QueryOrganizationByEmailOrCodeArgs = {
  emailOrCode: Scalars["String"]["input"];
};

export type QueryOrganizationByIdArgs = {
  id: Scalars["Int"]["input"];
};

export type QueryProfessionalArgs = {
  id?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryProfessionalExistsArgs = {
  email: Scalars["String"]["input"];
};

export type QueryProfessionalsArgs = {
  input: ProfessionalsInput;
};

export type QueryProfessionalsForCurrentHumanArgs = {
  input?: InputMaybe<ProfessionalsForCurrentHumanInput>;
};

export type QueryProfessionalsV2Args = {
  after?: InputMaybe<Scalars["String"]["input"]>;
  before?: InputMaybe<Scalars["String"]["input"]>;
  first?: InputMaybe<Scalars["Int"]["input"]>;
  last?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryQuestionForUserAtEntryPointArgs = {
  input: EntryPointsInput;
};

export type QueryVideoConsultBarchartEmployeesWithAnAmountOfConsultsArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryVideoConsultCardAverageConsultPerEmployeeArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryVideoConsultCardCancelledConsultsArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryVideoConsultCardCompletedConsultsArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryVideoConsultCardNoShowConsultsArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryVideoConsultFunnelArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWellbeingChallengesArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWellbeingEnergyGaugeArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWellbeingProductivityGaugeArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type QueryWellbeingStressGaugeArgs = {
  organizationID?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Question = {
  __typename?: "Question";
  category: QuestionsCategory;
  component?: Maybe<QuestionsComponent>;
  id: Scalars["Int"]["output"];
  nextQuestionId?: Maybe<Scalars["Int"]["output"]>;
  options?: Maybe<Scalars["JSON"]["output"]>;
  questionType: QuestionsType;
  title: Scalars["String"]["output"];
  translationKey?: Maybe<Scalars["String"]["output"]>;
};

export type QuestionsCategory =
  | "b2b"
  | "call_quality"
  | "end_of_treatment"
  | "match_quality"
  | "nps"
  | "professional_quality"
  | "share_with_bloomup";

export type QuestionsComponent = "checkbox" | "dropdown" | "radio" | "toggle";

export type QuestionsType =
  | "likert"
  | "multi_select"
  | "open"
  | "single_select"
  | "slider"
  | "yes_no"
  | "yes_no_maybe";

export type Region = {
  __typename?: "Region";
  descriptionTranslationKey: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  imgUrl: Scalars["String"]["output"];
  titleTranslationKey: Scalars["String"]["output"];
};

export type RegisterHumanInput = {
  birthDate?: InputMaybe<Scalars["Date"]["input"]>;
  contactForFeedback?: InputMaybe<Scalars["Boolean"]["input"]>;
  email: Scalars["String"]["input"];
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  fromMindlab?: InputMaybe<Scalars["Boolean"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mindlabNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
  organizationCode?: InputMaybe<Scalars["String"]["input"]>;
  password: Scalars["String"]["input"];
  preferredLanguage: Language;
};

export type RegisterHumanWithInviteInput = {
  email?: InputMaybe<Scalars["String"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  onboardedAt?: InputMaybe<Scalars["String"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
};

export type Reimbursement = WithDates &
  WithId & {
    __typename?: "Reimbursement";
    createdAt: Scalars["DateTime"]["output"];
    id: Scalars["Int"]["output"];
    reimbursementSubmission?: Maybe<ReimbursementSubmission>;
    updatedAt: Scalars["DateTime"]["output"];
  };

export type ReimbursementInput = {
  consultationUuid: Scalars["String"]["input"];
  nationalId: Scalars["String"]["input"];
};

export type ReimbursementSubmission = WithDates &
  WithId & {
    __typename?: "ReimbursementSubmission";
    createdAt: Scalars["DateTime"]["output"];
    id: Scalars["Int"]["output"];
    submittedAt?: Maybe<Scalars["DateTime"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
  };

export type RequestConsultationAsHumanInput = {
  fromMatching: Scalars["Boolean"]["input"];
  professionalId: Scalars["Int"]["input"];
  startTime: Scalars["DateTime"]["input"];
  type: ConsultationType;
};

export type RequestIntroAsHumanInput = {
  fromMatching: Scalars["Boolean"]["input"];
  professionalId: Scalars["Int"]["input"];
  startTime: Scalars["DateTime"]["input"];
};

export type RequestedByType = "HUMAN" | "PROFESSIONAL";

/** Input object for rescheduling a consultation. */
export type RescheduleConsultationInput = {
  id: Scalars["Int"]["input"];
  message: Scalars["String"]["input"];
  price?: InputMaybe<Scalars["Float"]["input"]>;
  scheduledFrom: Scalars["DateTime"]["input"];
  scheduledTo: Scalars["DateTime"]["input"];
};

export type RestrictedClient = {
  __typename?: "RestrictedClient";
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  description?: Maybe<Scalars["String"]["output"]>;
  email?: Maybe<Scalars["String"]["output"]>;
  human?: Maybe<Human>;
  humanId?: Maybe<Scalars["Int"]["output"]>;
  id?: Maybe<Scalars["Int"]["output"]>;
  professionalId?: Maybe<Scalars["Int"]["output"]>;
  status?: Maybe<ClientStatus>;
};

/** The roles a user can have */
export type RoleType =
  | "ADMIN"
  | "HUMAN"
  | "ORGANIZATION_ADMIN"
  | "PROFESSIONAL";

export type Secrets2Fa = {
  __typename?: "Secrets2FA";
  qrCode: Scalars["String"]["output"];
  secret: Scalars["String"]["output"];
};

export type SortDirection = "asc" | "desc";

export type SpecialtiesThemeCombo = {
  __typename?: "SpecialtiesThemeCombo";
  id: Scalars["String"]["output"];
  primaryColor: Scalars["String"]["output"];
  secondaryColor: Scalars["String"]["output"];
  subcategories: Array<Maybe<SubCategory>>;
  theme: Scalars["String"]["output"];
  tooltip?: Maybe<Scalars["String"]["output"]>;
  translationKey: Scalars["String"]["output"];
};

export type StartMatchingV2Input = {
  age: Scalars["Int"]["input"];
  language: Language;
  orgCode?: InputMaybe<Scalars["String"]["input"]>;
  prefillTreatment?: InputMaybe<Scalars["String"]["input"]>;
  refererModuleID?: InputMaybe<Scalars["String"]["input"]>;
};

export type SubCategory = {
  __typename?: "SubCategory";
  id: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  tooltip?: Maybe<Scalars["String"]["output"]>;
  translationKey: Scalars["String"]["output"];
};

export type SubmitLocationStepInput = {
  countryId?: InputMaybe<Scalars["String"]["input"]>;
  regionId?: InputMaybe<Scalars["String"]["input"]>;
};

export type SubmitMatchingStepResponse = {
  __typename?: "SubmitMatchingStepResponse";
  matchedHuman: MatchedHuman;
  matchingToken: Scalars["String"]["output"];
  nextStep: Scalars["String"]["output"];
};

export type Subtopic = {
  __typename?: "Subtopic";
  descriptionTranslationKey: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  imageUrl: Scalars["String"]["output"];
  titleTranslationKey: Scalars["String"]["output"];
};

export type TokenResponse = {
  __typename?: "TokenResponse";
  /**
   * the accessToken is a JWT that contains the role_type and user_id (UUID) of the user, if login succeeds.
   * The user_id can be used to fetch the associated Professional / Patient.
   */
  accessToken?: Maybe<Scalars["String"]["output"]>;
  /** the mindlabToken is a JWT that is used for the mindlab rest-api. The response can be found at https://github.com/we-are-coding/mindlab-backend/blob/main/src/api/AuthEndpoint.ts . */
  mindlabToken?: Maybe<Scalars["String"]["output"]>;
  /**
   * the refreshToken is a JWT that can be used to refresh the accessToken if it expires
   * without having to login again.
   */
  refreshToken?: Maybe<Scalars["String"]["output"]>;
};

export type Topic = {
  __typename?: "Topic";
  descriptionTranslationKey: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  imageUrl: Scalars["String"]["output"];
  subtopics: Array<Subtopic>;
  titleTranslationKey: Scalars["String"]["output"];
};

export type Treatment = "COACHING" | "SELFHELP" | "THERAPY";

export type TreatmentsResponse = {
  __typename?: "TreatmentsResponse";
  availableTreatments: Array<Treatment>;
  module?: Maybe<Module>;
  proposedTreatment?: Maybe<Treatment>;
};

export type UpdateCalendarEventInput = {
  allDay?: InputMaybe<Scalars["Boolean"]["input"]>;
  id: Scalars["Int"]["input"];
  returnAsFullCalendar?: InputMaybe<Scalars["Boolean"]["input"]>;
  scheduledFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  scheduledTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateConsultationInput = {
  fromMatching?: InputMaybe<Scalars["Boolean"]["input"]>;
  humanCallQuality?: InputMaybe<Scalars["Int"]["input"]>;
  humanNps?: InputMaybe<Scalars["Int"]["input"]>;
  id?: InputMaybe<Scalars["Int"]["input"]>;
  message?: InputMaybe<MessageInput>;
  price?: InputMaybe<Scalars["Float"]["input"]>;
  professionalCallQuality?: InputMaybe<Scalars["Int"]["input"]>;
  scheduledFrom?: InputMaybe<Scalars["DateTime"]["input"]>;
  scheduledTo?: InputMaybe<Scalars["DateTime"]["input"]>;
  status?: InputMaybe<ConsultationStatus>;
  therapistWithoutBloomup?: InputMaybe<Scalars["Boolean"]["input"]>;
  uuid: Scalars["String"]["input"];
};

export type UpdateCurrentUserInput = {
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  language?: InputMaybe<Language>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  mindlabNewsletter?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type UpdateHumanInput = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  deletedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  firstName?: InputMaybe<Scalars["String"]["input"]>;
  lastName?: InputMaybe<Scalars["String"]["input"]>;
  onboardedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
  organizationId?: InputMaybe<Scalars["Int"]["input"]>;
  password?: InputMaybe<Scalars["String"]["input"]>;
  phone?: InputMaybe<Scalars["String"]["input"]>;
  preferredLanguage?: InputMaybe<Scalars["String"]["input"]>;
  /** The gender of a professional that a Human prefers to work with. */
  preferredProfessionalGender?: InputMaybe<Scalars["String"]["input"]>;
  /** Professionals that are linked to this Human. */
  professionals?: InputMaybe<Array<Scalars["Int"]["input"]>>;
  timezone?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateProfessionalRateInput = {
  coachingRate?: InputMaybe<Scalars["Float"]["input"]>;
  therapyDuration?: InputMaybe<Scalars["Int"]["input"]>;
  therapyRate?: InputMaybe<Scalars["Float"]["input"]>;
};

export type UpdateProfessionalSubtopicsInput = {
  primary: Scalars["Boolean"]["input"];
  subtopicIds: Array<Scalars["String"]["input"]>;
};

/** Every account is a user, see attached human or professional for persona specifc details */
export type User = {
  __typename?: "User";
  /**
   * The organization this user is a admin of. Will be null when this user is not a admin of an organization
   * @deprecated Use collection type (adminOrganizations) instead
   */
  adminOfOrganization?: Maybe<Organization>;
  /** The organizations this user is a admin of. Will be null when this user is not a admin of an organization */
  adminOrganizations?: Maybe<Array<Maybe<Organization>>>;
  /** User's date of birth. */
  birthDate?: Maybe<Scalars["DateTime"]["output"]>;
  /** Date at which the user was created */
  createdAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** User's first e-mail address. */
  email: Scalars["String"]["output"];
  /** User's first name. */
  firstName?: Maybe<Scalars["String"]["output"]>;
  /** The human persona for this user. Will be null when this user does not act as a human */
  human?: Maybe<Human>;
  id: Scalars["String"]["output"];
  /** Whether the user has organization admin access. */
  isOrgAdmin?: Maybe<Scalars["Boolean"]["output"]>;
  /** User's last name. */
  lastName?: Maybe<Scalars["String"]["output"]>;
  /** Boolean that indicates whether the client wants to receive newsletters or not. */
  mindlabNewsletter?: Maybe<Scalars["Boolean"]["output"]>;
  /** Id that identifies the user within the mindlab database */
  mindlabUserId?: Maybe<Scalars["String"]["output"]>;
  /** Whether or not a user has completed (Professional / Human) onboarding. */
  onboardedAt?: Maybe<Scalars["DateTime"]["output"]>;
  /** User's phone number. */
  phone?: Maybe<Scalars["String"]["output"]>;
  /**
   * The preferred language for this user. He / she will see all text presented in this language.
   * This is also the language that will be the default language used in consultations.
   */
  preferredLanguage: Language;
  /** The professional persona for this user. Will be null when this user does not act as a professional */
  professional?: Maybe<Professional>;
  /** The roll of the user. */
  roleType: RoleType;
  timezone: Scalars["String"]["output"];
  twoFactorAuthEnabled?: Maybe<Scalars["Boolean"]["output"]>;
};

export type UserFile = {
  __typename?: "UserFile";
  collectionName: Scalars["String"]["output"];
  fileName: Scalars["String"]["output"];
  id: Scalars["Int"]["output"];
  mimeType: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  url?: Maybe<Scalars["String"]["output"]>;
};

export type VideoCallV2 = {
  __typename?: "VideoCallV2";
  attendeeInfo: ChimeAttendeeInfo;
  meetingInfo: ChimeMeetingInfo;
};

/** This file contains datastructures that are common in multiple types */
export type WithDates = {
  /** Time and date when this user was created. */
  createdAt: Scalars["DateTime"]["output"];
  /** Time and date of the last update to this user. */
  updatedAt: Scalars["DateTime"]["output"];
};

export type WithId = {
  /** The database ID of this entity */
  id: Scalars["Int"]["output"];
};

export type ConsultationOrder = {
  scheduledFrom: SortDirection;
};

/** This is the type for wellbeing challenges. */
export type WellbeingChallengesResult = {
  __typename?: "wellbeingChallengesResult";
  /** This is the count (times chosen by users) of the challenge. */
  count: Scalars["Int"]["output"];
  /** This is the id of the challenge. */
  id: Scalars["Int"]["output"];
  /** This is the name (translation key) of the challenge. */
  name: Scalars["String"]["output"];
};

export type AddressFragment = {
  __typename?: "Address";
  id: number;
  country?: string | null;
  createdAt: string;
  location?: string | null;
  postcode?: string | null;
  street?: string | null;
  updatedAt: string;
} & { " $fragmentName"?: "AddressFragment" };

export type ResetPasswordMutationVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type ResetPasswordMutation = {
  __typename?: "Mutation";
  resetPassword: boolean;
};

export type BillingInformationFragment = {
  __typename?: "BillingInformation";
  id: number;
  accountNumber?: string | null;
  createdAt: string;
  email?: string | null;
  taxId?: string | null;
  updatedAt: string;
  address?:
    | ({ __typename?: "Address" } & {
        " $fragmentRefs"?: { AddressFragment: AddressFragment };
      })
    | null;
} & { " $fragmentName"?: "BillingInformationFragment" };

export type FullCalendarEventFragment = {
  __typename?: "FullCalendarEvent";
  id: string;
  allDay: boolean;
  end: string;
  start: string;
  extendedProps: {
    __typename?: "ExtendedProps";
    status?: string | null;
    type: CalendarEventTypes;
  };
} & { " $fragmentName"?: "FullCalendarEventFragment" };

export type CreateFullCalendarEventMutationVariables = Exact<{
  input: CalendarEventInput;
}>;

export type CreateFullCalendarEventMutation = {
  __typename?: "Mutation";
  createCalendarEvent?:
    | { __typename?: "CalendarEvent" }
    | ({ __typename?: "FullCalendarEvent" } & {
        " $fragmentRefs"?: {
          FullCalendarEventFragment: FullCalendarEventFragment;
        };
      })
    | null;
};

export type UpdateCalendarEventMutationVariables = Exact<{
  input: UpdateCalendarEventInput;
}>;

export type UpdateCalendarEventMutation = {
  __typename?: "Mutation";
  updateCalendarEvent?:
    | { __typename?: "CalendarEvent" }
    | ({ __typename?: "FullCalendarEvent" } & {
        " $fragmentRefs"?: {
          FullCalendarEventFragment: FullCalendarEventFragment;
        };
      })
    | null;
};

export type CopyCalendarEventsMutationVariables = Exact<{
  input: CopyCalendarEventsInput;
}>;

export type CopyCalendarEventsMutation = {
  __typename?: "Mutation";
  copyCalendarEvents?: Array<
    | { __typename?: "CalendarEvent" }
    | ({ __typename?: "FullCalendarEvent" } & {
        " $fragmentRefs"?: {
          FullCalendarEventFragment: FullCalendarEventFragment;
        };
      })
    | null
  > | null;
};

export type DeleteCalendarEventsMutationVariables = Exact<{
  input: DeleteCalendarEventsInput;
}>;

export type DeleteCalendarEventsMutation = {
  __typename?: "Mutation";
  deleteCalendarEvents?: Array<number | null> | null;
};

export type GetFullCalendarEventsQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars["DateTime"]["input"]>;
  startDate?: InputMaybe<Scalars["DateTime"]["input"]>;
}>;

export type GetFullCalendarEventsQuery = {
  __typename?: "Query";
  calendarEvents?: Array<
    | { __typename?: "CalendarEvent" }
    | ({ __typename?: "FullCalendarEvent" } & {
        " $fragmentRefs"?: {
          FullCalendarEventFragment: FullCalendarEventFragment;
        };
      })
    | null
  > | null;
};

export type CashTransactionFragment = {
  __typename?: "CashTransaction";
  id?: number | null;
  amount: number;
  createdAt?: string | null;
  status: CashTransactionStatusType;
  updatedAt?: string | null;
} & { " $fragmentName"?: "CashTransactionFragment" };

export type GetCashLastTransactionByConsultationIdQueryVariables = Exact<{
  consultationId: Scalars["Int"]["input"];
}>;

export type GetCashLastTransactionByConsultationIdQuery = {
  __typename?: "Query";
  lastCashTransactionByConsultationId?:
    | ({ __typename?: "CashTransaction" } & {
        " $fragmentRefs"?: { CashTransactionFragment: CashTransactionFragment };
      })
    | null;
};

export type ClientForProfessionalFragment = {
  __typename?: "Client";
  id?: number | null;
  createdAt?: string | null;
  description?: string | null;
  email?: string | null;
  humanId?: number | null;
  status?: ClientStatus | null;
  updatedAt?: string | null;
  human?:
    | ({ __typename?: "Human" } & {
        " $fragmentRefs"?: {
          HumanWithOrganizationFragment: HumanWithOrganizationFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "ClientForProfessionalFragment" };

export type RestrictedClientForProfessionalFragment = {
  __typename?: "RestrictedClient";
  id?: number | null;
  createdAt?: string | null;
  description?: string | null;
  email?: string | null;
  humanId?: number | null;
  professionalId?: number | null;
  status?: ClientStatus | null;
  human?:
    | ({ __typename?: "Human" } & {
        " $fragmentRefs"?: {
          HumanWithOrganizationFragment: HumanWithOrganizationFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "RestrictedClientForProfessionalFragment" };

export type ClientFragment = {
  __typename?: "Client";
  id?: number | null;
  createdAt?: string | null;
  description?: string | null;
  email?: string | null;
  status?: ClientStatus | null;
  updatedAt?: string | null;
  human?: {
    __typename?: "Human";
    id: number;
    canPayWithCredits: boolean;
    creditsLeft?: number | null;
  } | null;
  professional?: {
    __typename?: "Professional";
    id: number;
    firstName?: string | null;
    lastName?: string | null;
  } | null;
} & { " $fragmentName"?: "ClientFragment" };

export type InviteClientMutationVariables = Exact<{
  input: AddClientInput;
}>;

export type InviteClientMutation = {
  __typename?: "Mutation";
  inviteClient?: boolean | null;
};

export type AcceptInviteMutationVariables = Exact<{
  input: AcceptInviteInput;
}>;

export type AcceptInviteMutation = {
  __typename?: "Mutation";
  acceptInvite?:
    | ({ __typename?: "Client"; id?: number | null } & {
        " $fragmentRefs"?: { ClientFragment: ClientFragment };
      })
    | null;
};

export type ClientsForProfessionalQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ClientsForProfessionalQuery = {
  __typename?: "Query";
  clientsForProfessional?: {
    __typename?: "ClientsConnection";
    edges?: Array<{
      __typename?: "ClientEdge";
      node?:
        | ({ __typename?: "Client" } & {
            " $fragmentRefs"?: {
              ClientForProfessionalFragment: ClientForProfessionalFragment;
            };
          })
        | ({ __typename?: "RestrictedClient" } & {
            " $fragmentRefs"?: {
              RestrictedClientForProfessionalFragment: RestrictedClientForProfessionalFragment;
            };
          })
        | null;
    } | null> | null;
  } | null;
};

export type CommonConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  acceptedByHuman?: boolean | null;
  acceptedByProfessional?: boolean | null;
  createdAt: string;
  expectedReimbursementDate?: string | null;
  requestedBy?: RequestedByType | null;
  scheduledFrom: string;
  scheduledTo: string;
  status: ConsultationStatus;
  type?: ConsultationType | null;
  updatedAt: string;
  uuid: string;
  cashTransaction?:
    | ({ __typename?: "CashTransaction" } & {
        " $fragmentRefs"?: { CashTransactionFragment: CashTransactionFragment };
      })
    | null;
  creditTransactions: Array<{
    __typename?: "CreditTransaction";
    id: number;
    amount: number;
  }>;
  message?:
    | ({ __typename?: "Message" } & {
        " $fragmentRefs"?: { MessageFragment: MessageFragment };
      })
    | null;
} & { " $fragmentName"?: "CommonConsultationFragment" };

export type ProfessionalForConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  professionalId?: number | null;
  professional?: {
    __typename?: "Professional";
    id: number;
    consultationLanguages: Array<string | null>;
    email: string;
    firstName?: string | null;
    lastName?: string | null;
    phone?: string | null;
    profile?: string | null;
    standardRate?: number | null;
    avatar?: { __typename?: "Avatar"; url?: string | null } | null;
  } | null;
} & { " $fragmentName"?: "ProfessionalForConsultationFragment" };

export type HumanForConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  humanId?: number | null;
  human?:
    | ({ __typename?: "Human" } & {
        " $fragmentRefs"?: {
          HumanWithOrganizationFragment: HumanWithOrganizationFragment;
        };
      })
    | null;
} & { " $fragmentName"?: "HumanForConsultationFragment" };

export type ConsultationForCallFragment = ({ __typename?: "Consultation" } & {
  " $fragmentRefs"?: {
    CommonConsultationFragment: CommonConsultationFragment;
    HumanForConsultationFragment: HumanForConsultationFragment;
    ProfessionalForConsultationFragment: ProfessionalForConsultationFragment;
  };
}) & { " $fragmentName"?: "ConsultationForCallFragment" };

export type ConsultationFragment = ({ __typename?: "Consultation" } & {
  " $fragmentRefs"?: {
    CommonConsultationFragment: CommonConsultationFragment;
    HumanForConsultationFragment: HumanForConsultationFragment;
    ProfessionalForConsultationFragment: ProfessionalForConsultationFragment;
  };
}) & { " $fragmentName"?: "ConsultationFragment" };

export type ConsultationWithPaymentFragment = ({
  __typename?: "Consultation";
  cashTransaction?:
    | ({ __typename?: "CashTransaction" } & {
        " $fragmentRefs"?: { CashTransactionFragment: CashTransactionFragment };
      })
    | null;
} & {
  " $fragmentRefs"?: {
    CommonConsultationFragment: CommonConsultationFragment;
    ProfessionalForConsultationFragment: ProfessionalForConsultationFragment;
  };
}) & { " $fragmentName"?: "ConsultationWithPaymentFragment" };

export type CreateConsultationMutationVariables = Exact<{
  input: CreateConsultationInput;
}>;

export type CreateConsultationMutation = {
  __typename?: "Mutation";
  createConsultation?:
    | ({ __typename?: "Consultation" } & {
        " $fragmentRefs"?: { ConsultationFragment: ConsultationFragment };
      })
    | null;
};

export type ConsultationUpdateMutationVariables = Exact<{
  input: UpdateConsultationInput;
}>;

export type ConsultationUpdateMutation = {
  __typename?: "Mutation";
  updateConsultation?:
    | ({ __typename?: "Consultation" } & {
        " $fragmentRefs"?: { ConsultationFragment: ConsultationFragment };
      })
    | null;
};

export type ConfirmConsultationMutationMutationVariables = Exact<{
  input: ConfirmConsultationInput;
}>;

export type ConfirmConsultationMutationMutation = {
  __typename?: "Mutation";
  confirmConsultation?: {
    __typename?: "Consultation";
    id: number;
    acceptedByHuman?: boolean | null;
    acceptedByProfessional?: boolean | null;
    status: ConsultationStatus;
    uuid: string;
  } | null;
};

export type AllHumanConsultationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllHumanConsultationsQuery = {
  __typename?: "Query";
  allConsultationsForHuman?: {
    __typename?: "ConsultationsConnection";
    edges: Array<{
      __typename?: "ConsultationEdge";
      node: { __typename?: "Consultation" } & {
        " $fragmentRefs"?: {
          ConsultationWithPaymentFragment: ConsultationWithPaymentFragment;
        };
      };
    }>;
  } | null;
};

export type AllProfessionalConsultationsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type AllProfessionalConsultationsQuery = {
  __typename?: "Query";
  allConsultationsForProfessional?: {
    __typename?: "ConsultationsConnection";
    edges: Array<{
      __typename?: "ConsultationEdge";
      node: { __typename?: "Consultation" } & {
        " $fragmentRefs"?: { ConsultationFragment: ConsultationFragment };
      };
    }>;
  } | null;
};

export type ConsultationsForProfessionalAndHumanResolverQueryVariables = Exact<{
  humanId: Scalars["Int"]["input"];
}>;

export type ConsultationsForProfessionalAndHumanResolverQuery = {
  __typename?: "Query";
  consultationsForProfessionalAndHuman?: {
    __typename?: "ConsultationsConnection";
    edges: Array<{
      __typename?: "ConsultationEdge";
      node: { __typename?: "Consultation" } & {
        " $fragmentRefs"?: { ConsultationFragment: ConsultationFragment };
      };
    }>;
  } | null;
};

export type FetchConsultationForCallByUuidQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type FetchConsultationForCallByUuidQuery = {
  __typename?: "Query";
  consultation?:
    | ({ __typename?: "Consultation" } & {
        " $fragmentRefs"?: {
          ConsultationForCallFragment: ConsultationForCallFragment;
        };
      })
    | null;
};

export type FetchConsultationWithCashTransactionQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type FetchConsultationWithCashTransactionQuery = {
  __typename?: "Query";
  consultation?:
    | ({ __typename?: "Consultation"; id: number } & {
        " $fragmentRefs"?: {
          ConsultationWithPaymentFragment: ConsultationWithPaymentFragment;
        };
      })
    | null;
};

export type HumanFragment = {
  __typename?: "Human";
  id: number;
  birthDate?: string | null;
  createdAt: string;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  onboardedAt?: string | null;
  organizationId?: number | null;
  phone?: string | null;
  preferredLanguage: Language;
  timezone: string;
  updatedAt?: string | null;
} & { " $fragmentName"?: "HumanFragment" };

export type HumanRegistrationFragment = {
  __typename?: "Human";
  id: number;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
} & { " $fragmentName"?: "HumanRegistrationFragment" };

export type HumanWithOrganizationFragment = ({
  __typename?: "Human";
  canPayWithCredits: boolean;
  creditsLeft?: number | null;
  organizationId?: number | null;
  organization?:
    | ({ __typename?: "Organization" } & {
        " $fragmentRefs"?: { OrganizationFragment: OrganizationFragment };
      })
    | null;
} & { " $fragmentRefs"?: { HumanFragment: HumanFragment } }) & {
  " $fragmentName"?: "HumanWithOrganizationFragment";
};

export type RegisterHumanWithInviteMutationVariables = Exact<{
  input: RegisterHumanWithInviteInput;
  inviteToken: Scalars["String"]["input"];
}>;

export type RegisterHumanWithInviteMutation = {
  __typename?: "Mutation";
  registerHumanWithInvite?: {
    __typename?: "HumanWithTokens";
    accessToken: string;
    refreshToken: string;
    human?:
      | ({ __typename?: "Human"; id: number } & {
          " $fragmentRefs"?: {
            HumanRegistrationFragment: HumanRegistrationFragment;
          };
        })
      | null;
  } | null;
};

export type UpdateHumanMutationVariables = Exact<{
  input: UpdateHumanInput;
}>;

export type UpdateHumanMutation = {
  __typename?: "Mutation";
  updateHuman?:
    | ({ __typename?: "Human" } & {
        " $fragmentRefs"?: { HumanFragment: HumanFragment };
      })
    | null;
};

export type HumanQueryVariables = Exact<{ [key: string]: never }>;

export type HumanQuery = {
  __typename?: "Query";
  human?:
    | ({ __typename?: "Human" } & {
        " $fragmentRefs"?: { HumanFragment: HumanFragment };
      })
    | null;
};

export type UseSelectTranslationStringInputFragment = {
  __typename?: "MultiLanguageString";
  en?: string | null;
  fr?: string | null;
  nl?: string | null;
} & { " $fragmentName"?: "UseSelectTranslationStringInputFragment" };

export type InitialDataQueryVariables = Exact<{ [key: string]: never }>;

export type InitialDataQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    email: string;
    firstName?: string | null;
    isOrgAdmin?: boolean | null;
    lastName?: string | null;
    onboardedAt?: string | null;
    phone?: string | null;
    preferredLanguage: Language;
    timezone: string;
    human?: {
      __typename?: "Human";
      id: number;
      canPayWithCredits: boolean;
    } | null;
    professional?: {
      __typename?: "Professional";
      id: number;
      avatar?: { __typename?: "Avatar"; url?: string | null } | null;
    } | null;
  } | null;
};

export type MessageFragment = {
  __typename?: "Message";
  id?: number | null;
  body?: string | null;
  fromProfessional?: boolean | null;
} & { " $fragmentName"?: "MessageFragment" };

export type OrganizationFragment = {
  __typename?: "Organization";
  id: number;
  coachingEnabled: boolean;
  coachingsPerHuman?: number | null;
  code?: string | null;
  color?: string | null;
  consultsPerHuman?: number | null;
  creditsPerHuman?: number | null;
  mindlabBusinessId?: string | null;
  mindlabEnabled: boolean;
  slug: string;
  ssoEnabled: boolean;
  videoEnabled: boolean;
  logoUrl: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
  name: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
} & { " $fragmentName"?: "OrganizationFragment" };

export type CreatePaymentMutationVariables = Exact<{
  input: PaymentInput;
}>;

export type CreatePaymentMutation = {
  __typename?: "Mutation";
  payForConsultation?: string | null;
};

export type PracticeFragment = {
  __typename?: "Practice";
  id: number;
  chatTherapy?: boolean | null;
  createdAt: string;
  offlineTherapy?: boolean | null;
  onlineTherapy?: boolean | null;
  phoneTherapy?: boolean | null;
  updatedAt: string;
  address?:
    | ({ __typename?: "Address" } & {
        " $fragmentRefs"?: { AddressFragment: AddressFragment };
      })
    | null;
} & { " $fragmentName"?: "PracticeFragment" };

export type ProfessionalExtraFragment = {
  __typename?: "Professional";
  id: number;
  cmNumber?: string | null;
  visumNumber?: string | null;
  billingInformation?:
    | ({ __typename?: "BillingInformation" } & {
        " $fragmentRefs"?: {
          BillingInformationFragment: BillingInformationFragment;
        };
      })
    | null;
  practice?:
    | ({ __typename?: "Practice" } & {
        " $fragmentRefs"?: { PracticeFragment: PracticeFragment };
      })
    | null;
} & { " $fragmentName"?: "ProfessionalExtraFragment" };

export type ProfessionalFragment = {
  __typename?: "Professional";
  id: number;
  birthDate?: string | null;
  clientStop?: boolean | null;
  consultationLanguages: Array<string | null>;
  createdAt: string;
  email: string;
  experienceSince?: string | null;
  firstName?: string | null;
  gender?: string | null;
  isFirstLine?: boolean | null;
  lastName?: string | null;
  phone?: string | null;
  preferredLanguage: Language;
  profile?: string | null;
  roleType?: string | null;
  standardRate?: number | null;
  supervision?: boolean | null;
  therapyTypes?: string | null;
  timezone: string;
  training?: string | null;
  type?: string | null;
  updatedAt?: string | null;
  verifiedAt?: string | null;
  website?: string | null;
  avatar?: { __typename?: "Avatar"; url?: string | null } | null;
} & { " $fragmentName"?: "ProfessionalFragment" };

export type ProfessionalFullFragment = ({
  __typename?: "Professional";
  licenseFiles?: Array<{
    __typename?: "UserFile";
    id: number;
    collectionName: string;
    fileName: string;
    mimeType: string;
    name: string;
    url?: string | null;
  } | null> | null;
} & {
  " $fragmentRefs"?: {
    ProfessionalFragment: ProfessionalFragment;
    ProfessionalExtraFragment: ProfessionalExtraFragment;
  };
}) & { " $fragmentName"?: "ProfessionalFullFragment" };

export type ProfessionalInfoForHumanFragment = {
  __typename?: "Professional";
  id: number;
  availability?: Array<string> | null;
  birthDate?: string | null;
  consultationLanguages: Array<string | null>;
  email: string;
  experienceSince?: string | null;
  firstName?: string | null;
  gender?: string | null;
  lastName?: string | null;
  onboardedAt?: string | null;
  phone?: string | null;
  profile?: string | null;
  standardRate?: number | null;
  therapyTypes?: string | null;
  timezone: string;
  training?: string | null;
  type?: string | null;
  website?: string | null;
  avatar?: { __typename?: "Avatar"; url?: string | null } | null;
  practice?:
    | ({ __typename?: "Practice" } & {
        " $fragmentRefs"?: { PracticeFragment: PracticeFragment };
      })
    | null;
  user: { __typename?: "User"; id: string; preferredLanguage: Language };
} & { " $fragmentName"?: "ProfessionalInfoForHumanFragment" };

export type RegisterProfessionalMutationVariables = Exact<{
  input: ProfessionalRegistrationInput;
}>;

export type RegisterProfessionalMutation = {
  __typename?: "Mutation";
  registerProfessional?: boolean | null;
};

export type UpdateProfessionalMutationVariables = Exact<{
  input: ProfessionalInput;
}>;

export type UpdateProfessionalMutation = {
  __typename?: "Mutation";
  updateProfessional?:
    | ({ __typename?: "Professional" } & {
        " $fragmentRefs"?: {
          ProfessionalFullFragment: ProfessionalFullFragment;
        };
      })
    | null;
};

export type FullProfessionalProfileQueryVariables = Exact<{
  [key: string]: never;
}>;

export type FullProfessionalProfileQuery = {
  __typename?: "Query";
  professional?:
    | ({ __typename?: "Professional" } & {
        " $fragmentRefs"?: {
          ProfessionalFragment: ProfessionalFragment;
          ProfessionalExtraFragment: ProfessionalExtraFragment;
        };
      })
    | null;
};

export type ProfessionalCurrentQueryVariables = Exact<{ [key: string]: never }>;

export type ProfessionalCurrentQuery = {
  __typename?: "Query";
  professional?:
    | ({ __typename?: "Professional" } & {
        " $fragmentRefs"?: { ProfessionalFragment: ProfessionalFragment };
      })
    | null;
};

export type ProfessionalsForHumanQueryVariables = Exact<{
  input?: InputMaybe<ProfessionalsForCurrentHumanInput>;
}>;

export type ProfessionalsForHumanQuery = {
  __typename?: "Query";
  professionalsForCurrentHuman?: {
    __typename?: "ProfessionalsConnection";
    edges?: Array<{
      __typename?: "ProfessionalEdge";
      node?:
        | ({ __typename?: "Professional" } & {
            " $fragmentRefs"?: {
              ProfessionalInfoForHumanFragment: ProfessionalInfoForHumanFragment;
            };
          })
        | null;
    } | null> | null;
  } | null;
};

export type ProfessionalExistsQueryVariables = Exact<{
  email: Scalars["String"]["input"];
}>;

export type ProfessionalExistsQuery = {
  __typename?: "Query";
  professionalExists?: boolean | null;
};

export type QualityQuestionFragment = {
  __typename?: "Question";
  id: number;
  category: QuestionsCategory;
  component?: QuestionsComponent | null;
  nextQuestionId?: number | null;
  options?: any | null;
  questionType: QuestionsType;
  title: string;
  translationKey?: string | null;
} & { " $fragmentName"?: "QualityQuestionFragment" };

export type GetQuestionByIdQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type GetQuestionByIdQuery = {
  __typename?: "Query";
  getQuestionById?:
    | ({ __typename?: "Question" } & {
        " $fragmentRefs"?: { QualityQuestionFragment: QualityQuestionFragment };
      })
    | null;
};

export type QuestionForUserAtEntryPointQueryVariables = Exact<{
  input: EntryPointsInput;
}>;

export type QuestionForUserAtEntryPointQuery = {
  __typename?: "Query";
  questionForUserAtEntryPoint?:
    | ({ __typename?: "Question" } & {
        " $fragmentRefs"?: { QualityQuestionFragment: QualityQuestionFragment };
      })
    | null;
};

export type RefreshAccessTokenMutationVariables = Exact<{
  refreshToken: Scalars["String"]["input"];
}>;

export type RefreshAccessTokenMutation = {
  __typename?: "Mutation";
  refreshAccessTokenV2: {
    __typename?: "TokenResponse";
    accessToken?: string | null;
    refreshToken?: string | null;
  };
};

export type ConsultationDateSelectionAvailabilityQueryVariables = Exact<{
  consultationType: ConsultationType;
  professionalId: Scalars["Int"]["input"];
}>;

export type ConsultationDateSelectionAvailabilityQuery = {
  __typename?: "Query";
  professional?: {
    __typename?: "Professional";
    id: number;
    availabilityV2: Array<string>;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      firstName?: string | null;
    };
  } | null;
};

export type ConsultationDetailConsultationFragment = ({
  __typename?: "Consultation";
  id: number;
} & {
  " $fragmentRefs"?: {
    ConsultationInfoConsultationFragment: ConsultationInfoConsultationFragment;
  };
}) & { " $fragmentName"?: "ConsultationDetailConsultationFragment" };

export type ConsultationDetailQueryVariables = Exact<{
  consultationId: Scalars["String"]["input"];
}>;

export type ConsultationDetailQuery = {
  __typename?: "Query";
  consultation?:
    | ({
        __typename?: "Consultation";
        id: number;
        human?: {
          __typename?: "Human";
          id: number;
          organization?:
            | ({
                __typename?: "Organization";
                id: number;
                profile: { __typename?: "MultiLanguageString" } & {
                  " $fragmentRefs"?: {
                    UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
                  };
                };
              } & {
                " $fragmentRefs"?: {
                  OrgProfileDialogOrganizationFragment: OrgProfileDialogOrganizationFragment;
                };
              })
            | null;
        } | null;
      } & {
        " $fragmentRefs"?: {
          ConsultationDetailConsultationFragment: ConsultationDetailConsultationFragment;
        };
      })
    | null;
};

export type ConsultationInfoConsultationFragment = ({
  __typename?: "Consultation";
  id: number;
  status: ConsultationStatus;
  type?: ConsultationType | null;
  cashTransaction?: {
    __typename?: "CashTransaction";
    id?: number | null;
    status: CashTransactionStatusType;
  } | null;
  creditTransactions: Array<{ __typename?: "CreditTransaction"; id: number }>;
  human?: {
    __typename?: "Human";
    id: number;
    creditBalance?: {
      __typename?: "HumanCreditBalance";
      total?: number | null;
    } | null;
    organization?:
      | ({
          __typename?: "Organization";
          id: number;
          name: { __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          };
        } & {
          " $fragmentRefs"?: {
            OrgProfileDialogOrganizationFragment: OrgProfileDialogOrganizationFragment;
          };
        })
      | null;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
      phone?: string | null;
    };
  } | null;
  message?: {
    __typename?: "Message";
    id?: number | null;
    body?: string | null;
  } | null;
  professional?: {
    __typename?: "Professional";
    id: number;
    user: {
      __typename?: "User";
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
  } | null;
} & {
  " $fragmentRefs"?: {
    ReimbursementInfoConsultationFragment: ReimbursementInfoConsultationFragment;
  };
}) & { " $fragmentName"?: "ConsultationInfoConsultationFragment" };

export type ReimbursementInfoConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  expectedReimbursementDate?: string | null;
  scheduledFrom: string;
  uuid: string;
  cashTransaction?: {
    __typename?: "CashTransaction";
    id?: number | null;
    status: CashTransactionStatusType;
  } | null;
  human?: {
    __typename?: "Human";
    id: number;
    mutuality?: { __typename?: "Mutuality"; id: string; title: string } | null;
  } | null;
} & { " $fragmentName"?: "ReimbursementInfoConsultationFragment" };

export type ReimbursementInfoMutualitiesQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ReimbursementInfoMutualitiesQuery = {
  __typename?: "Query";
  mutualities: Array<{
    __typename?: "Mutuality";
    id: string;
    preferred: boolean;
    title: string;
  }>;
};

export type HumanSidebarQueryVariables = Exact<{ [key: string]: never }>;

export type HumanSidebarQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    isOrgAdmin?: boolean | null;
    human?: {
      __typename?: "Human";
      id: number;
      organization?: {
        __typename?: "Organization";
        id: number;
        mindlabEnabled: boolean;
      } | null;
    } | null;
  } | null;
};

export type ButtonBarConsultationFragment = ({
  __typename?: "Consultation";
  id: number;
  professional?: {
    __typename?: "Professional";
    id: number;
    user: { __typename?: "User"; id: string };
  } | null;
} & {
  " $fragmentRefs"?: {
    BookingSidePanelConsultationFragment: BookingSidePanelConsultationFragment;
    ClientInfoSidePanelConsultationFragment: ClientInfoSidePanelConsultationFragment;
  };
}) & { " $fragmentName"?: "ButtonBarConsultationFragment" };

export type StartCallPopupConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  scheduledFrom: string;
  type?: ConsultationType | null;
  uuid: string;
  cashTransaction?: {
    __typename?: "CashTransaction";
    id?: number | null;
    status: CashTransactionStatusType;
  } | null;
  creditTransactions: Array<{ __typename?: "CreditTransaction"; id: number }>;
  human?: {
    __typename?: "Human";
    id: number;
    user: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    };
  } | null;
  professional?: {
    __typename?: "Professional";
    id: number;
    user: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
    };
  } | null;
} & { " $fragmentName"?: "StartCallPopupConsultationFragment" };

export type VideoCallConsultationQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type VideoCallConsultationQuery = {
  __typename?: "Query";
  consultation?:
    | ({
        __typename?: "Consultation";
        id: number;
        type?: ConsultationType | null;
        uuid: string;
        professional?: {
          __typename?: "Professional";
          id: number;
          user: { __typename?: "User"; id: string };
        } | null;
      } & {
        " $fragmentRefs"?: {
          ButtonBarConsultationFragment: ButtonBarConsultationFragment;
          StartCallPopupConsultationFragment: StartCallPopupConsultationFragment;
        };
      })
    | null;
};

export type UserJoinedConsultationMutationVariables = Exact<{
  consultationId: Scalars["Int"]["input"];
}>;

export type UserJoinedConsultationMutation = {
  __typename?: "Mutation";
  userJoinedConsultation: {
    __typename?: "Consultation";
    id: number;
    status: ConsultationStatus;
  };
};

export type StartVideoCallV2MutationVariables = Exact<{
  consultationUuid: Scalars["String"]["input"];
}>;

export type StartVideoCallV2Mutation = {
  __typename?: "Mutation";
  startVideoCallV2?: {
    __typename?: "VideoCallV2";
    attendeeInfo: {
      __typename?: "ChimeAttendeeInfo";
      AttendeeId: string;
      ExternalUserId: string;
      JoinToken: string;
    };
    meetingInfo: {
      __typename?: "ChimeMeetingInfo";
      ExternalMeetingId?: string | null;
      MediaRegion: string;
      MeetingId: string;
      MediaPlacement: {
        __typename?: "ChimeMediaPlacement";
        AudioFallbackUrl: string;
        AudioHostUrl: string;
        ScreenDataUrl: string;
        ScreenSharingUrl: string;
        ScreenViewingUrl: string;
        SignalingUrl: string;
      };
    };
  } | null;
};

export type BookingSidePanelConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  human?:
    | ({ __typename?: "Human"; id: number } & {
        " $fragmentRefs"?: {
          RequestConsultationHumanInfoFragment: RequestConsultationHumanInfoFragment;
        };
      })
    | null;
  professional?: { __typename?: "Professional"; id: number } | null;
} & { " $fragmentName"?: "BookingSidePanelConsultationFragment" };

export type ClientInfoSidePanelConsultationFragment = {
  __typename?: "Consultation";
  id: number;
  cashTransaction?: {
    __typename?: "CashTransaction";
    id?: number | null;
    amount: number;
    status: CashTransactionStatusType;
  } | null;
  human?: {
    __typename?: "Human";
    id: number;
    creditBalance?: {
      __typename?: "HumanCreditBalance";
      total?: number | null;
    } | null;
    organization?:
      | ({
          __typename?: "Organization";
          id: number;
          name: { __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          };
        } & {
          " $fragmentRefs"?: {
            OrgProfileDialogOrganizationFragment: OrgProfileDialogOrganizationFragment;
          };
        })
      | null;
    user: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      preferredLanguage: Language;
      timezone: string;
    };
  } | null;
  professional?: {
    __typename?: "Professional";
    id: number;
    user: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      timezone: string;
    };
  } | null;
} & { " $fragmentName"?: "ClientInfoSidePanelConsultationFragment" };

export type OrgProfileDialogOrganizationFragment = {
  __typename?: "Organization";
  id: number;
  coachingEnabled: boolean;
  contractEndDate?: string | null;
  contractStartDate?: string | null;
  creditsPerCoaching?: number | null;
  creditsPerConsult?: number | null;
  creditsPerHuman?: number | null;
  hasRenewalContract: boolean;
  mindlabEnabled: boolean;
  videoEnabled: boolean;
  name: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
  profile: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
} & { " $fragmentName"?: "OrgProfileDialogOrganizationFragment" };

export type ChoosePasswordV2MutationVariables = Exact<{
  input: ChoosePasswordV2Input;
}>;

export type ChoosePasswordV2Mutation = {
  __typename?: "Mutation";
  choosePasswordV2: boolean;
};

export type ConfirmConsultationMutationVariables = Exact<{
  input: ConfirmConsultationInput;
}>;

export type ConfirmConsultationMutation = {
  __typename?: "Mutation";
  confirmConsultation?: {
    __typename?: "Consultation";
    id: number;
    acceptedByHuman?: boolean | null;
    acceptedByProfessional?: boolean | null;
    status: ConsultationStatus;
    uuid: string;
  } | null;
};

export type ProfessionalListItemFragment = {
  __typename?: "Professional";
  id: number;
  user: {
    __typename?: "User";
    firstName?: string | null;
    lastName?: string | null;
  } & { " $fragmentRefs"?: { AvatarFragment: AvatarFragment } };
} & { " $fragmentName"?: "ProfessionalListItemFragment" };

export type ProfessionalsForHumanOverviewQueryVariables = Exact<{
  input: ProfessionalsForCurrentHumanInput;
}>;

export type ProfessionalsForHumanOverviewQuery = {
  __typename?: "Query";
  professionalsForCurrentHuman?: {
    __typename?: "ProfessionalsConnection";
    totalCount?: number | null;
    edges?: Array<{
      __typename?: "ProfessionalEdge";
      cursor?: string | null;
      node?:
        | ({
            __typename?: "Professional";
            id: number;
            user: { __typename?: "User" } & {
              " $fragmentRefs"?: {
                ViewOnlyProfileInfoFragment: ViewOnlyProfileInfoFragment;
              };
            };
          } & {
            " $fragmentRefs"?: {
              ProfessionalListItemFragment: ProfessionalListItemFragment;
              ViewOnlyProfessionalProfileFragment: ViewOnlyProfessionalProfileFragment;
            };
          })
        | null;
    } | null> | null;
  } | null;
};

export type HumanProfilePageQueryVariables = Exact<{ [key: string]: never }>;

export type HumanProfilePageQuery = {
  __typename?: "Query";
  human?:
    | ({
        __typename?: "Human";
        id: number;
        creditBalance?: {
          __typename?: "HumanCreditBalance";
          total?: number | null;
        } | null;
        organization?: {
          __typename?: "Organization";
          id: number;
          name: { __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          };
        } | null;
      } & {
        " $fragmentRefs"?: { HumanMutualityFragment: HumanMutualityFragment };
      })
    | null;
};

export type MutualitySelectMutationVariables = Exact<{
  mutualityId: Scalars["String"]["input"];
}>;

export type MutualitySelectMutation = {
  __typename?: "Mutation";
  updateHumanMutuality?: {
    __typename?: "Human";
    id: number;
    mutuality?: { __typename?: "Mutuality"; id: string; title: string } | null;
  } | null;
};

export type SelectMutualitesQueryVariables = Exact<{ [key: string]: never }>;

export type SelectMutualitesQuery = {
  __typename?: "Query";
  mutualities: Array<{ __typename?: "Mutuality"; id: string; title: string }>;
};

export type HumanMutualityFragment = {
  __typename?: "Human";
  id: number;
  mutuality?: { __typename?: "Mutuality"; id: string; title: string } | null;
} & { " $fragmentName"?: "HumanMutualityFragment" };

export type CompleteHumanRegistrationMutationVariables = Exact<{
  input: CompleteHumanRegistrationInput;
}>;

export type CompleteHumanRegistrationMutation = {
  __typename?: "Mutation";
  completeHumanRegistration?: {
    __typename?: "Human";
    id: number;
    user: {
      __typename?: "User";
      id: string;
      firstName?: string | null;
      lastName?: string | null;
      phone?: string | null;
    };
  } | null;
};

export type RequestConsultationFormUserQueryVariables = Exact<{
  [key: string]: never;
}>;

export type RequestConsultationFormUserQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    human?:
      | ({
          __typename?: "Human";
          id: number;
          mutuality?: {
            __typename?: "Mutuality";
            id: string;
            title: string;
          } | null;
          organization?:
            | ({
                __typename?: "Organization";
                id: number;
                coachingEnabled: boolean;
                videoEnabled: boolean;
              } & {
                " $fragmentRefs"?: {
                  CostSentenceOrganizationFragment: CostSentenceOrganizationFragment;
                };
              })
            | null;
        } & {
          " $fragmentRefs"?: {
            CostSentenceHumanFragment: CostSentenceHumanFragment;
          };
        })
      | null;
  } | null;
};

export type RequestConsultationFormProfQueryVariables = Exact<{
  professionalId?: InputMaybe<Scalars["Int"]["input"]>;
}>;

export type RequestConsultationFormProfQuery = {
  __typename?: "Query";
  professional?:
    | ({
        __typename?: "Professional";
        id: number;
        coachingEnabled: boolean;
        therapyEnabled: boolean;
      } & {
        " $fragmentRefs"?: {
          CostSentenceProfessionalFragment: CostSentenceProfessionalFragment;
        };
      })
    | null;
};

export type LoginMutationVariables = Exact<{
  input: LoginV2Input;
}>;

export type LoginMutation = {
  __typename?: "Mutation";
  loginV2:
    | { __typename?: "LoginV2FailureResponse"; reason: LoginFailureReason }
    | {
        __typename?: "TokenResponse";
        accessToken?: string | null;
        refreshToken?: string | null;
      };
};

export type SsoUrlQueryVariables = Exact<{
  redirectUrl?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SsoUrlQuery = { __typename?: "Query"; getSSOUrl: string };

export type LoginWithSsoMutationVariables = Exact<{
  input: LoginWithSsoInput;
}>;

export type LoginWithSsoMutation = {
  __typename?: "Mutation";
  loginWithSSO:
    | { __typename?: "LoginV2FailureResponse" }
    | {
        __typename?: "TokenResponse";
        accessToken?: string | null;
        mindlabToken?: string | null;
        refreshToken?: string | null;
      };
};

export type ProposedMatchesQueryVariables = Exact<{ [key: string]: never }>;

export type ProposedMatchesQuery = {
  __typename?: "Query";
  currentMatchedHuman?:
    | ({
        __typename?: "MatchedHuman";
        id: number;
        proposedMatches: Array<
          { __typename?: "Professional"; id: number } & {
            " $fragmentRefs"?: { ProfCardProfFragment: ProfCardProfFragment };
          }
        >;
        subtopic?: {
          __typename?: "Subtopic";
          id: string;
          titleTranslationKey: string;
        } | null;
      } & {
        " $fragmentRefs"?: {
          ProfCardMatchedHumanFragment: ProfCardMatchedHumanFragment;
        };
      })
    | null;
};

export type CostSentenceProfessionalFragment = {
  __typename?: "Professional";
  id: number;
  coachingRate?: number | null;
  standardRate?: number | null;
} & { " $fragmentName"?: "CostSentenceProfessionalFragment" };

export type CostSentenceOrganizationFragment = {
  __typename?: "Organization";
  id: number;
  coachingEnabled: boolean;
  coachingsPerHuman?: number | null;
  consultsPerHuman?: number | null;
  contractEndDate?: string | null;
  slug: string;
  videoEnabled: boolean;
  canCreditsBeUsed?: {
    __typename?: "CanCreditsBeUsed";
    forCoaching: boolean;
    forTherapy: boolean;
  } | null;
  name: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
} & { " $fragmentName"?: "CostSentenceOrganizationFragment" };

export type CostSentenceHumanFragment = {
  __typename?: "Human";
  id: number;
  creditBalance?: {
    __typename?: "HumanCreditBalance";
    remainingCoachingConsultations?: number | null;
    remainingTherapyConsultations?: number | null;
  } | null;
} & { " $fragmentName"?: "CostSentenceHumanFragment" };

export type ProfCardMatchedHumanFragment = {
  __typename?: "MatchedHuman";
  id: number;
  treatment?: Treatment | null;
  human?:
    | ({ __typename?: "Human"; id: number } & {
        " $fragmentRefs"?: {
          CostSentenceHumanFragment: CostSentenceHumanFragment;
        };
      })
    | null;
  mutuality?: { __typename?: "Mutuality"; id: string; title: string } | null;
  organization?:
    | ({ __typename?: "Organization"; id: number } & {
        " $fragmentRefs"?: {
          CostSentenceOrganizationFragment: CostSentenceOrganizationFragment;
        };
      })
    | null;
  subtopic?: { __typename?: "Subtopic"; id: string } | null;
} & { " $fragmentName"?: "ProfCardMatchedHumanFragment" };

export type ProfCardProfFragment = ({
  __typename?: "Professional";
  id: number;
  availabilityV2: Array<string>;
  coachingEnabled: boolean;
  consultationLanguages: Array<string | null>;
  experienceSince?: string | null;
  gender?: string | null;
  isOnline: boolean;
  type?: string | null;
  website?: string | null;
  avatar?: { __typename?: "Avatar"; url?: string | null } | null;
  primarySubtopics: Array<{
    __typename?: "Subtopic";
    id: string;
    titleTranslationKey: string;
  }>;
  profileDescription: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
  secondarySubtopics: Array<{
    __typename?: "Subtopic";
    id: string;
    titleTranslationKey: string;
  }>;
  user: {
    __typename?: "User";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
  };
} & {
  " $fragmentRefs"?: {
    CostSentenceProfessionalFragment: CostSentenceProfessionalFragment;
  };
}) & { " $fragmentName"?: "ProfCardProfFragment" };

export type MatchConsultationQueryVariables = Exact<{ [key: string]: never }>;

export type MatchConsultationQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    matchConsultation?: {
      __typename?: "Consultation";
      id: number;
      scheduledFrom: string;
      type?: ConsultationType | null;
      professional?: {
        __typename?: "Professional";
        id: number;
        avatar?: { __typename?: "Avatar"; url?: string | null } | null;
        user: {
          __typename?: "User";
          id: string;
          firstName?: string | null;
          lastName?: string | null;
        };
      } | null;
    } | null;
    subtopic?: {
      __typename?: "Subtopic";
      id: string;
      titleTranslationKey: string;
    } | null;
  } | null;
};

export type CountriesQueryVariables = Exact<{ [key: string]: never }>;

export type CountriesQuery = {
  __typename?: "Query";
  countries: Array<{
    __typename?: "Country";
    id: string;
    descriptionTranslationKey: string;
    imgUrl: string;
    titleTranslationKey: string;
    regions?: Array<{
      __typename?: "Region";
      id: string;
      descriptionTranslationKey: string;
      imgUrl: string;
      titleTranslationKey: string;
    }> | null;
  }>;
};

export type LocationStepMatchedHumanQueryVariables = Exact<{
  [key: string]: never;
}>;

export type LocationStepMatchedHumanQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    noLocation: boolean;
    country?: { __typename?: "Country"; id: string } | null;
    region?: { __typename?: "Region"; id: string } | null;
  } | null;
};

export type SubmitLocationStepMutationVariables = Exact<{
  input: SubmitLocationStepInput;
}>;

export type SubmitLocationStepMutation = {
  __typename?: "Mutation";
  submitLocationStep: {
    __typename?: "SubmitMatchingStepResponse";
    matchingToken: string;
    nextStep: string;
    matchedHuman: {
      __typename?: "MatchedHuman";
      id: number;
      noLocation: boolean;
      country?: { __typename?: "Country"; id: string } | null;
      mutualityOptions: {
        __typename?: "MutualitiesResponse";
        otherMutualities: Array<{ __typename?: "Mutuality"; id: string }>;
        regionMutualities: Array<{ __typename?: "Mutuality"; id: string }>;
      };
      region?: { __typename?: "Region"; id: string } | null;
    };
  };
};

export type RequestIntroConsultMutationVariables = Exact<{
  input: RequestIntroAsHumanInput;
}>;

export type RequestIntroConsultMutation = {
  __typename?: "Mutation";
  requestIntroAsHuman: {
    __typename?: "Consultation";
    id: number;
    isInstant?: boolean | null;
    scheduledFrom: string;
    professional?: {
      __typename?: "Professional";
      id: number;
      avatar?: { __typename?: "Avatar"; url?: string | null } | null;
      user: {
        __typename?: "User";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      };
    } | null;
  };
};

export type MutualitiesQueryVariables = Exact<{ [key: string]: never }>;

export type MutualitiesQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    noMutuality: boolean;
    mutuality?: { __typename?: "Mutuality"; id: string } | null;
    mutualityOptions: {
      __typename?: "MutualitiesResponse";
      otherMutualities: Array<{
        __typename?: "Mutuality";
        id: string;
        descriptionTranslationKey?: string | null;
        imgUrl: string;
        linkUrlTranslationKey: string;
        preferred: boolean;
        title: string;
      }>;
      regionMutualities: Array<{
        __typename?: "Mutuality";
        id: string;
        descriptionTranslationKey?: string | null;
        imgUrl: string;
        linkUrlTranslationKey: string;
        preferred: boolean;
        title: string;
      }>;
    };
    organization?: {
      __typename?: "Organization";
      id: number;
      consultsPerHuman?: number | null;
      videoEnabled: boolean;
      name: { __typename?: "MultiLanguageString" } & {
        " $fragmentRefs"?: {
          UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
        };
      };
    } | null;
  } | null;
};

export type SubmitMutualityStepMutationVariables = Exact<{
  mutualityId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SubmitMutualityStepMutation = {
  __typename?: "Mutation";
  submitMutualityStep: {
    __typename?: "SubmitMatchingStepResponse";
    matchingToken: string;
    nextStep: string;
    matchedHuman: {
      __typename?: "MatchedHuman";
      id: number;
      noMutuality: boolean;
      mutuality?: { __typename?: "Mutuality"; id: string } | null;
    };
  };
};

export type StartMatchingV2MutationVariables = Exact<{
  input: StartMatchingV2Input;
}>;

export type StartMatchingV2Mutation = {
  __typename?: "Mutation";
  startMatchingV2: {
    __typename?: "SubmitMatchingStepResponse";
    matchingToken: string;
    nextStep: string;
  };
};

export type LoginInMatchingMutationVariables = Exact<{
  input: LoginV2Input;
}>;

export type LoginInMatchingMutation = {
  __typename?: "Mutation";
  loginV2:
    | { __typename?: "LoginV2FailureResponse"; reason: LoginFailureReason }
    | {
        __typename?: "TokenResponse";
        accessToken?: string | null;
        refreshToken?: string | null;
      };
};

export type RegisterInMatchingMutationVariables = Exact<{
  input: RegisterHumanInput;
}>;

export type RegisterInMatchingMutation = {
  __typename?: "Mutation";
  registerHumanV2: {
    __typename?: "TokenResponse";
    accessToken?: string | null;
    refreshToken?: string | null;
  };
};

export type SubtopicsQueryVariables = Exact<{ [key: string]: never }>;

export type SubtopicsQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    noSubtopic: boolean;
    subtopic?: { __typename?: "Subtopic"; id: string } | null;
    topic?: {
      __typename?: "Topic";
      id: string;
      descriptionTranslationKey: string;
      imageUrl: string;
      titleTranslationKey: string;
      subtopics: Array<{
        __typename?: "Subtopic";
        id: string;
        descriptionTranslationKey: string;
        imageUrl: string;
        titleTranslationKey: string;
      }>;
    } | null;
  } | null;
};

export type SubmitSubtopicStepMutationVariables = Exact<{
  subtopicId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SubmitSubtopicStepMutation = {
  __typename?: "Mutation";
  submitSubtopicStep: {
    __typename?: "SubmitMatchingStepResponse";
    matchingToken: string;
    nextStep: string;
    matchedHuman: {
      __typename?: "MatchedHuman";
      id: number;
      noSubtopic: boolean;
      subtopic?: { __typename?: "Subtopic"; id: string } | null;
      treatmentOptions: {
        __typename?: "TreatmentsResponse";
        availableTreatments: Array<Treatment>;
        proposedTreatment?: Treatment | null;
        module?: { __typename?: "Module"; id: string } | null;
      };
    };
  };
};

export type TopicsQueryVariables = Exact<{ [key: string]: never }>;

export type TopicsQuery = {
  __typename?: "Query";
  topics: Array<{
    __typename?: "Topic";
    id: string;
    descriptionTranslationKey: string;
    imageUrl: string;
    titleTranslationKey: string;
  }>;
};

export type TopicStepMatchedHumanQueryVariables = Exact<{
  [key: string]: never;
}>;

export type TopicStepMatchedHumanQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    noTopic: boolean;
    topic?: { __typename?: "Topic"; id: string } | null;
  } | null;
};

export type SubmitTopicStepMutationVariables = Exact<{
  topicId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type SubmitTopicStepMutation = {
  __typename?: "Mutation";
  submitTopicStep: {
    __typename?: "SubmitMatchingStepResponse";
    matchingToken: string;
    nextStep: string;
    matchedHuman: {
      __typename?: "MatchedHuman";
      id: number;
      noTopic: boolean;
      topic?: { __typename?: "Topic"; id: string } | null;
      treatmentOptions: {
        __typename?: "TreatmentsResponse";
        availableTreatments: Array<Treatment>;
        proposedTreatment?: Treatment | null;
        module?: { __typename?: "Module"; id: string } | null;
      };
    };
  };
};

export type TreatmentsQueryVariables = Exact<{ [key: string]: never }>;

export type TreatmentsQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    organization?: {
      __typename?: "Organization";
      id: number;
      code?: string | null;
      mindlabEnabled: boolean;
      ssoEnabled: boolean;
      name: { __typename?: "MultiLanguageString" } & {
        " $fragmentRefs"?: {
          UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
        };
      };
    } | null;
    treatmentOptions: {
      __typename?: "TreatmentsResponse";
      availableTreatments: Array<Treatment>;
      proposedTreatment?: Treatment | null;
      module?: {
        __typename?: "Module";
        id: string;
        url: string;
        title: { __typename?: "MultiLanguageString" } & {
          " $fragmentRefs"?: {
            UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
          };
        };
      } | null;
    };
  } | null;
};

export type SubmitTreatmentStepMutationVariables = Exact<{
  treatment: Treatment;
}>;

export type SubmitTreatmentStepMutation = {
  __typename?: "Mutation";
  submitTreatmentStep: {
    __typename?: "SubmitMatchingStepResponse";
    matchingToken: string;
    nextStep: string;
    matchedHuman: {
      __typename?: "MatchedHuman";
      id: number;
      treatment?: Treatment | null;
    };
  };
};

export type WaitingRoomQueryVariables = Exact<{ [key: string]: never }>;

export type WaitingRoomQuery = {
  __typename?: "Query";
  currentMatchedHuman?: {
    __typename?: "MatchedHuman";
    id: number;
    matchConsultation?: {
      __typename?: "Consultation";
      id: number;
      uuid: string;
      professional?: {
        __typename?: "Professional";
        id: number;
        availabilityV2: Array<string>;
        user: { __typename?: "User"; id: string; firstName?: string | null };
      } | null;
    } | null;
    subtopic?: {
      __typename?: "Subtopic";
      id: string;
      titleTranslationKey: string;
    } | null;
  } | null;
};

export type WaitingRoomCancelConsultationMutationVariables = Exact<{
  input: CancelConsultationInput;
}>;

export type WaitingRoomCancelConsultationMutation = {
  __typename?: "Mutation";
  cancelConsultation: { __typename?: "Consultation"; id: number };
};

export type DashboardsQueryVariables = Exact<{ [key: string]: never }>;

export type DashboardsQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    adminOrganizations?: Array<{
      __typename?: "Organization";
      id: number;
      videoEnabled: boolean;
      contractDashboardUrl?:
        | ({ __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          })
        | null;
      interestDashboardUrl?:
        | ({ __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          })
        | null;
      mentalWellbeingDashboardUrl?:
        | ({ __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          })
        | null;
      usageDashboardUrl?:
        | ({ __typename?: "MultiLanguageString" } & {
            " $fragmentRefs"?: {
              UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
            };
          })
        | null;
    } | null> | null;
  } | null;
};

export type OrganizationHeaderFragment = {
  __typename?: "Organization";
  id: number;
  pobosEnabled: boolean;
} & { " $fragmentName"?: "OrganizationHeaderFragment" };

export type OrganizationNavBarFragment = {
  __typename?: "Organization";
  id: number;
  ssoEnabled: boolean;
  logoUrl: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
  name: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
} & { " $fragmentName"?: "OrganizationNavBarFragment" };

export type OrganizationApproachFragment = {
  __typename?: "Organization";
  id: number;
  coachingEnabled: boolean;
  coachingsPerHuman?: number | null;
  code?: string | null;
  consultsPerHuman?: number | null;
  creditsPerHuman?: number | null;
  mindlabBusinessId?: string | null;
  mindlabEnabled: boolean;
  pobosEnabled: boolean;
  ssoEnabled: boolean;
  videoEnabled: boolean;
} & { " $fragmentName"?: "OrganizationApproachFragment" };

export type VerifyOrganizationPageQueryVariables = Exact<{
  emailOrCode: Scalars["String"]["input"];
}>;

export type VerifyOrganizationPageQuery = {
  __typename?: "Query";
  organizationByEmailOrCode?:
    | ({ __typename?: "Organization" } & {
        " $fragmentRefs"?: { OrganizationFragment: OrganizationFragment };
      })
    | null;
};

export type OrganisationLandingPageQueryVariables = Exact<{
  emailOrCode: Scalars["String"]["input"];
}>;

export type OrganisationLandingPageQuery = {
  __typename?: "Query";
  organizationByEmailOrCode?:
    | ({ __typename?: "Organization" } & {
        " $fragmentRefs"?: {
          OrganizationFragment: OrganizationFragment;
          OrganizationApproachFragment: OrganizationApproachFragment;
          OrganizationHeaderFragment: OrganizationHeaderFragment;
          OrganizationNavBarFragment: OrganizationNavBarFragment;
        };
      })
    | null;
};

export type ColleagueQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type ColleagueQuery = {
  __typename?: "Query";
  professional?:
    | ({
        __typename?: "Professional";
        id: number;
        user: { __typename?: "User"; id: string } & {
          " $fragmentRefs"?: {
            ViewOnlyProfileInfoFragment: ViewOnlyProfileInfoFragment;
          };
        };
      } & {
        " $fragmentRefs"?: {
          ViewOnlyProfessionalProfileFragment: ViewOnlyProfessionalProfileFragment;
        };
      })
    | null;
};

export type ColleagueFragment = {
  __typename?: "Professional";
  id: number;
  therapyTypes?: string | null;
  primarySubtopics: Array<{
    __typename?: "Subtopic";
    id: string;
    titleTranslationKey: string;
  }>;
  user: {
    __typename?: "User";
    id: string;
    firstName?: string | null;
    lastName?: string | null;
  } & { " $fragmentRefs"?: { AvatarFragment: AvatarFragment } };
} & { " $fragmentName"?: "ColleagueFragment" };

export type ColleagueNodeFragment = ({
  __typename?: "Professional";
  id: number;
  firstName?: string | null;
  lastName?: string | null;
} & { " $fragmentRefs"?: { ColleagueFragment: ColleagueFragment } }) & {
  " $fragmentName"?: "ColleagueNodeFragment";
};

export type ColleaguesQueryVariables = Exact<{
  input: ProfessionalsInput;
}>;

export type ColleaguesQuery = {
  __typename?: "Query";
  professionals?: {
    __typename?: "ProfessionalsConnection";
    totalCount?: number | null;
    edges?: Array<{
      __typename?: "ProfessionalEdge";
      cursor?: string | null;
      node?:
        | ({ __typename?: "Professional" } & {
            " $fragmentRefs"?: { ColleagueNodeFragment: ColleagueNodeFragment };
          })
        | null;
    } | null> | null;
  } | null;
};

export type ProfessionalRateOnboardingQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ProfessionalRateOnboardingQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    professional?: {
      __typename?: "Professional";
      id: number;
      coachingEnabled: boolean;
      coachingRate?: number | null;
      standardRate?: number | null;
      therapyEnabled: boolean;
    } | null;
  } | null;
};

export type UpdateProfessionalRateOnboardingMutationVariables = Exact<{
  input: UpdateProfessionalRateInput;
}>;

export type UpdateProfessionalRateOnboardingMutation = {
  __typename?: "Mutation";
  updateProfessionalRate: {
    __typename?: "Professional";
    id: number;
    coachingEnabled: boolean;
    coachingRate?: number | null;
    standardRate?: number | null;
    therapyEnabled: boolean;
  };
};

export type ToggleCoachingOnboardingMutationVariables = Exact<{
  input: Scalars["Boolean"]["input"];
}>;

export type ToggleCoachingOnboardingMutation = {
  __typename?: "Mutation";
  toggleCoachingEnabledForProfessional: {
    __typename?: "Professional";
    id: number;
    coachingEnabled: boolean;
  };
};

export type OnboardingSubtopicsQueryVariables = Exact<{ [key: string]: never }>;

export type OnboardingSubtopicsQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    professional?: {
      __typename?: "Professional";
      id: number;
      primarySubtopics: Array<{
        __typename?: "Subtopic";
        id: string;
        titleTranslationKey: string;
      }>;
      secondarySubtopics: Array<{
        __typename?: "Subtopic";
        id: string;
        titleTranslationKey: string;
      }>;
    } | null;
  } | null;
  subtopics: Array<{
    __typename?: "Subtopic";
    id: string;
    titleTranslationKey: string;
  }>;
};

export type OnboardProfessionalSubtopicsMutationVariables = Exact<{
  input: UpdateProfessionalSubtopicsInput;
}>;

export type OnboardProfessionalSubtopicsMutation = {
  __typename?: "Mutation";
  updateProfessionalSubtopics: {
    __typename?: "Professional";
    id: number;
    primarySubtopics: Array<{
      __typename?: "Subtopic";
      id: string;
      titleTranslationKey: string;
    }>;
    secondarySubtopics: Array<{
      __typename?: "Subtopic";
      id: string;
      titleTranslationKey: string;
    }>;
  };
};

export type ProfessionalProfileQueryVariables = Exact<{ [key: string]: never }>;

export type ProfessionalProfileQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    professional?:
      | ({
          __typename?: "Professional";
          id: number;
          coachingEnabled: boolean;
          therapyEnabled: boolean;
        } & {
          " $fragmentRefs"?: {
            RateSelectFragment: RateSelectFragment;
            SubtopicsOnProfessionalFragment: SubtopicsOnProfessionalFragment;
          };
        })
      | null;
  } | null;
};

export type ToggleCoachingEnabledForProfessionalMutationVariables = Exact<{
  input: Scalars["Boolean"]["input"];
}>;

export type ToggleCoachingEnabledForProfessionalMutation = {
  __typename?: "Mutation";
  toggleCoachingEnabledForProfessional: {
    __typename?: "Professional";
    id: number;
    coachingEnabled: boolean;
  };
};

export type ToggleTherapyEnabledForProfessionalMutationVariables = Exact<{
  input: Scalars["Boolean"]["input"];
}>;

export type ToggleTherapyEnabledForProfessionalMutation = {
  __typename?: "Mutation";
  toggleTherapyEnabledForProfessional: {
    __typename?: "Professional";
    id: number;
    therapyEnabled: boolean;
  };
};

export type ViewOnlyProfessionalProfileFragment = {
  __typename?: "Professional";
  id: number;
  consultationLanguages: Array<string | null>;
  experienceSince?: string | null;
  standardRate?: number | null;
  therapyTypes?: string | null;
  website?: string | null;
  practice?: {
    __typename?: "Practice";
    id: number;
    address?: {
      __typename?: "Address";
      id: number;
      postcode?: string | null;
      street?: string | null;
    } | null;
  } | null;
  primarySubtopics: Array<{
    __typename?: "Subtopic";
    id: string;
    descriptionTranslationKey: string;
    titleTranslationKey: string;
  }>;
  profileDescription: { __typename?: "MultiLanguageString" } & {
    " $fragmentRefs"?: {
      UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
    };
  };
  secondarySubtopics: Array<{
    __typename?: "Subtopic";
    id: string;
    descriptionTranslationKey: string;
    titleTranslationKey: string;
  }>;
} & { " $fragmentName"?: "ViewOnlyProfessionalProfileFragment" };

export type RateSelectFragment = {
  __typename?: "Professional";
  id: number;
  coachingEnabled: boolean;
  coachingRate?: number | null;
  standardRate?: number | null;
  therapyEnabled: boolean;
} & { " $fragmentName"?: "RateSelectFragment" };

export type UpdateProfessionalRateMutationVariables = Exact<{
  input: UpdateProfessionalRateInput;
}>;

export type UpdateProfessionalRateMutation = {
  __typename?: "Mutation";
  updateProfessionalRate: { __typename?: "Professional"; id: number } & {
    " $fragmentRefs"?: { RateSelectFragment: RateSelectFragment };
  };
};

export type SubtopicFragment = {
  __typename?: "Subtopic";
  id: string;
  descriptionTranslationKey: string;
  imageUrl: string;
  titleTranslationKey: string;
} & { " $fragmentName"?: "SubtopicFragment" };

export type SubtopicsOnProfessionalFragment = {
  __typename?: "Professional";
  id: number;
  primarySubtopics: Array<
    { __typename?: "Subtopic"; id: string } & {
      " $fragmentRefs"?: { SubtopicFragment: SubtopicFragment };
    }
  >;
  secondarySubtopics: Array<
    { __typename?: "Subtopic"; id: string } & {
      " $fragmentRefs"?: { SubtopicFragment: SubtopicFragment };
    }
  >;
} & { " $fragmentName"?: "SubtopicsOnProfessionalFragment" };

export type AllSubtopicsQueryVariables = Exact<{ [key: string]: never }>;

export type AllSubtopicsQuery = {
  __typename?: "Query";
  subtopics: Array<
    { __typename?: "Subtopic"; id: string } & {
      " $fragmentRefs"?: { SubtopicFragment: SubtopicFragment };
    }
  >;
};

export type UpdateProfessionalSubtopicsMutationVariables = Exact<{
  input: UpdateProfessionalSubtopicsInput;
}>;

export type UpdateProfessionalSubtopicsMutation = {
  __typename?: "Mutation";
  updateProfessionalSubtopics: { __typename?: "Professional"; id: number } & {
    " $fragmentRefs"?: {
      SubtopicsOnProfessionalFragment: SubtopicsOnProfessionalFragment;
    };
  };
};

export type MollieRedirectHumanQueryVariables = Exact<{ [key: string]: never }>;

export type MollieRedirectHumanQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    human?: {
      __typename?: "Human";
      id: number;
      mutuality?: {
        __typename?: "Mutuality";
        id: string;
        title: string;
      } | null;
    } | null;
  } | null;
};

export type PaymentPageHumanQueryVariables = Exact<{
  consultationUuid: Scalars["String"]["input"];
}>;

export type PaymentPageHumanQuery = {
  __typename?: "Query";
  consultation?: {
    __typename?: "Consultation";
    id: number;
    scheduledFrom: string;
    scheduledTo: string;
    type?: ConsultationType | null;
    uuid: string;
    cashTransaction?: {
      __typename?: "CashTransaction";
      id?: number | null;
      amount: number;
    } | null;
    human?: { __typename?: "Human"; id: number } | null;
    professional?: {
      __typename?: "Professional";
      id: number;
      user: {
        __typename?: "User";
        id: string;
        firstName?: string | null;
        lastName?: string | null;
      } & { " $fragmentRefs"?: { AvatarFragment: AvatarFragment } };
    } | null;
  } | null;
  currentUser?: {
    __typename?: "User";
    id: string;
    human?:
      | ({ __typename?: "Human"; id: number } & {
          " $fragmentRefs"?: {
            AffiliatedMutualityHumanFragment: AffiliatedMutualityHumanFragment;
          };
        })
      | null;
  } | null;
};

export type ReimbursementPageHumanQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ReimbursementPageHumanQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    human?: {
      __typename?: "Human";
      id: number;
      mutuality?: {
        __typename?: "Mutuality";
        id: string;
        title: string;
      } | null;
    } | null;
  } | null;
};

export type UpdateHumanMutualityOnReimbursementInfoMutationVariables = Exact<{
  mutualityId: Scalars["String"]["input"];
}>;

export type UpdateHumanMutualityOnReimbursementInfoMutation = {
  __typename?: "Mutation";
  updateHumanMutuality?: {
    __typename?: "Human";
    id: number;
    mutuality?: { __typename?: "Mutuality"; id: string; title: string } | null;
  } | null;
};

export type RequestReimbursementMutationVariables = Exact<{
  input: ReimbursementInput;
}>;

export type RequestReimbursementMutation = {
  __typename?: "Mutation";
  requestReimbursement?: { __typename?: "Reimbursement"; id: number } | null;
};

export type AffiliatedMutualityHumanFragment = {
  __typename?: "Human";
  id: number;
  mutuality?: { __typename?: "Mutuality"; id: string; title: string } | null;
} & { " $fragmentName"?: "AffiliatedMutualityHumanFragment" };

export type PaymentMutualitiesQueryVariables = Exact<{ [key: string]: never }>;

export type PaymentMutualitiesQuery = {
  __typename?: "Query";
  mutualities: Array<{
    __typename?: "Mutuality";
    id: string;
    preferred: boolean;
    title: string;
  }>;
};

export type UpdateHumanMutualityMutationVariables = Exact<{
  mutualityId?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type UpdateHumanMutualityMutation = {
  __typename?: "Mutation";
  updateHumanMutuality?: {
    __typename?: "Human";
    id: number;
    mutuality?: { __typename?: "Mutuality"; id: string } | null;
  } | null;
};

export type ClientConsultationDetailQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type ClientConsultationDetailQuery = {
  __typename?: "Query";
  consultation?: {
    __typename?: "Consultation";
    id: number;
    acceptedByHuman?: boolean | null;
    acceptedByProfessional?: boolean | null;
    bloomupFee?: number | null;
    duration: string;
    professionalFee?: number | null;
    scheduledFrom: string;
    scheduledTo: string;
    status: ConsultationStatus;
    type?: ConsultationType | null;
    uuid: string;
    cashTransaction?: {
      __typename?: "CashTransaction";
      id?: number | null;
      amount: number;
      status: CashTransactionStatusType;
    } | null;
    creditTransactions: Array<{
      __typename?: "CreditTransaction";
      id: number;
      amount: number;
    }>;
    human?: {
      __typename?: "Human";
      id: number;
      canPayWithCredits: boolean;
      creditsLeft?: number | null;
      organization?:
        | ({
            __typename?: "Organization";
            id: number;
            name: { __typename?: "MultiLanguageString" } & {
              " $fragmentRefs"?: {
                UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
              };
            };
          } & {
            " $fragmentRefs"?: {
              OrgProfileDialogOrganizationFragment: OrgProfileDialogOrganizationFragment;
            };
          })
        | null;
      user: {
        __typename?: "User";
        id: string;
        email: string;
        firstName?: string | null;
        lastName?: string | null;
        phone?: string | null;
      };
    } | null;
    matchedHuman?: {
      __typename?: "MatchedHuman";
      id: number;
      treatment?: Treatment | null;
      subtopic?: {
        __typename?: "Subtopic";
        id: string;
        titleTranslationKey: string;
      } | null;
      topic?: {
        __typename?: "Topic";
        id: string;
        titleTranslationKey: string;
      } | null;
    } | null;
    message?: {
      __typename?: "Message";
      id?: number | null;
      body?: string | null;
    } | null;
  } | null;
};

export type ProfessionalCancelConsultationQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type ProfessionalCancelConsultationQuery = {
  __typename?: "Query";
  consultation?: { __typename?: "Consultation"; id: number } | null;
};

export type ProfessionalCancelConsultationMutationMutationVariables = Exact<{
  input: CancelConsultationInput;
}>;

export type ProfessionalCancelConsultationMutationMutation = {
  __typename?: "Mutation";
  cancelConsultation: {
    __typename?: "Consultation";
    id: number;
    message?: {
      __typename?: "Message";
      id?: number | null;
      body?: string | null;
    } | null;
  };
};

export type ConsultationDetailActionsQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type ConsultationDetailActionsQuery = {
  __typename?: "Query";
  consultation?: {
    __typename?: "Consultation";
    id: number;
    acceptedByHuman?: boolean | null;
    acceptedByProfessional?: boolean | null;
    status: ConsultationStatus;
    type?: ConsultationType | null;
    uuid: string;
    human?: {
      __typename?: "Human";
      id: number;
      organization?:
        | ({
            __typename?: "Organization";
            id: number;
            name: { __typename?: "MultiLanguageString" } & {
              " $fragmentRefs"?: {
                UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
              };
            };
            profile: { __typename?: "MultiLanguageString" } & {
              " $fragmentRefs"?: {
                UseSelectTranslationStringInputFragment: UseSelectTranslationStringInputFragment;
              };
            };
          } & {
            " $fragmentRefs"?: {
              OrgProfileDialogOrganizationFragment: OrgProfileDialogOrganizationFragment;
            };
          })
        | null;
    } | null;
  } | null;
  currentUser?: { __typename?: "User"; id: string; email: string } | null;
};

export type ConfirmConsultationMutationProfessionalMutationVariables = Exact<{
  input: ConfirmConsultationInput;
}>;

export type ConfirmConsultationMutationProfessionalMutation = {
  __typename?: "Mutation";
  confirmConsultation?: {
    __typename?: "Consultation";
    id: number;
    acceptedByHuman?: boolean | null;
    acceptedByProfessional?: boolean | null;
    status: ConsultationStatus;
  } | null;
};

export type ProfessionalConsultationListFragment = {
  __typename?: "ConsultationsConnection";
  edges: Array<{
    __typename?: "ConsultationEdge";
    node: {
      __typename?: "Consultation";
      id: number;
      requestedBy?: RequestedByType | null;
      scheduledFrom: string;
      status: ConsultationStatus;
      uuid: string;
      cashTransaction?: {
        __typename?: "CashTransaction";
        id?: number | null;
        status: CashTransactionStatusType;
      } | null;
      human?: {
        __typename?: "Human";
        id: number;
        user: {
          __typename?: "User";
          id: string;
          email: string;
          firstName?: string | null;
          lastName?: string | null;
        } & { " $fragmentRefs"?: { AvatarFragment: AvatarFragment } };
      } | null;
    };
  }>;
} & { " $fragmentName"?: "ProfessionalConsultationListFragment" };

export type RequestConsultationProfessionalQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type RequestConsultationProfessionalQuery = {
  __typename?: "Query";
  professional?: {
    __typename?: "Professional";
    id: number;
    coachingEnabled: boolean;
    coachingRate?: number | null;
    standardRate?: number | null;
    therapyEnabled: boolean;
  } | null;
};

export type RequestConsultationClientsQueryVariables = Exact<{
  id: Scalars["Int"]["input"];
}>;

export type RequestConsultationClientsQuery = {
  __typename?: "Query";
  professional?: {
    __typename?: "Professional";
    id: number;
    clients: {
      __typename?: "ProfessionalHumanConnection";
      edges: Array<{
        __typename?: "ProfessionalHumanEdge";
        node: {
          __typename?: "Human";
          id: number;
          user: {
            __typename?: "User";
            id: string;
            email: string;
            firstName?: string | null;
            lastName?: string | null;
          };
        } & {
          " $fragmentRefs"?: {
            RequestConsultationHumanInfoFragment: RequestConsultationHumanInfoFragment;
          };
        };
      }>;
    };
  } | null;
};

export type ProfessionalRequestConsultationMutationVariables = Exact<{
  input: CreateConsultationInput;
}>;

export type ProfessionalRequestConsultationMutation = {
  __typename?: "Mutation";
  createConsultation?: {
    __typename?: "Consultation";
    id: number;
    uuid: string;
  } | null;
};

export type RequestConsultationHumanInfoFragment = {
  __typename?: "Human";
  id: number;
  canPayCoachingWithCredits: boolean;
  canPayConsultWithCredits: boolean;
  creditsLeft?: number | null;
  organization?: {
    __typename?: "Organization";
    id: number;
    coachingEnabled: boolean;
    videoEnabled: boolean;
  } | null;
} & { " $fragmentName"?: "RequestConsultationHumanInfoFragment" };

export type RescheduleConsultationDetailQueryVariables = Exact<{
  uuid: Scalars["String"]["input"];
}>;

export type RescheduleConsultationDetailQuery = {
  __typename?: "Query";
  consultation?: {
    __typename?: "Consultation";
    id: number;
    duration: string;
    scheduledFrom: string;
    scheduledTo: string;
    type?: ConsultationType | null;
    cashTransaction?: {
      __typename?: "CashTransaction";
      id?: number | null;
      amount: number;
      status: CashTransactionStatusType;
    } | null;
    creditTransactions: Array<{ __typename?: "CreditTransaction"; id: number }>;
    human?: {
      __typename?: "Human";
      id: number;
      canPayWithCredits: boolean;
      creditsLeft?: number | null;
    } | null;
  } | null;
};

export type ProfessionalRescheduleConsultationMutationVariables = Exact<{
  input: RescheduleConsultationInput;
}>;

export type ProfessionalRescheduleConsultationMutation = {
  __typename?: "Mutation";
  rescheduleConsultation: {
    __typename?: "Consultation";
    id: number;
    acceptedByProfessional?: boolean | null;
    duration: string;
    scheduledFrom: string;
    scheduledTo: string;
    status: ConsultationStatus;
    cashTransaction?: {
      __typename?: "CashTransaction";
      id?: number | null;
      amount: number;
    } | null;
    message?: {
      __typename?: "Message";
      id?: number | null;
      body?: string | null;
    } | null;
  };
};

export type ProfessionalCompletedConsultationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProfessionalCompletedConsultationsQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    professional?: { __typename?: "Professional"; id: number } | null;
  } | null;
  myProfessionalConsultations: {
    __typename?: "ConsultationsConnection";
    edges: Array<{ __typename?: "ConsultationEdge"; cursor?: string | null }>;
    pageInfo?: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
    } | null;
  } & {
    " $fragmentRefs"?: {
      ProfessionalConsultationListFragment: ProfessionalConsultationListFragment;
    };
  };
};

export type ProfessionalConsultationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars["String"]["input"]>;
}>;

export type ProfessionalConsultationsQuery = {
  __typename?: "Query";
  currentUser?: {
    __typename?: "User";
    id: string;
    professional?: { __typename?: "Professional"; id: number } | null;
  } | null;
  PlannedConsultations: {
    __typename?: "ConsultationsConnection";
    edges: Array<{ __typename?: "ConsultationEdge"; cursor?: string | null }>;
    pageInfo?: {
      __typename?: "PageInfo";
      endCursor?: string | null;
      hasNextPage: boolean;
    } | null;
  } & {
    " $fragmentRefs"?: {
      ProfessionalConsultationListFragment: ProfessionalConsultationListFragment;
    };
  };
  RequestedConsultations: { __typename?: "ConsultationsConnection" } & {
    " $fragmentRefs"?: {
      ProfessionalConsultationListFragment: ProfessionalConsultationListFragment;
    };
  };
};

export type ViewOnlyProfileInfoFragment = ({
  __typename?: "User";
  id: string;
  birthDate?: string | null;
  email: string;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  preferredLanguage: Language;
  timezone: string;
} & { " $fragmentRefs"?: { AvatarFragment: AvatarFragment } }) & {
  " $fragmentName"?: "ViewOnlyProfileInfoFragment";
};

export type AnswerQuestionMutationVariables = Exact<{
  input: AnswerInput;
}>;

export type AnswerQuestionMutation = {
  __typename?: "Mutation";
  answerQuestion?: boolean | null;
};

export type AvatarFragment = {
  __typename?: "User";
  id: string;
  firstName?: string | null;
  lastName?: string | null;
  professional?: {
    __typename?: "Professional";
    id: number;
    gender?: string | null;
    avatar?: { __typename?: "Avatar"; url?: string | null } | null;
  } | null;
} & { " $fragmentName"?: "AvatarFragment" };

export type LanguageDropdownUpdateMutationVariables = Exact<{
  language: Language;
}>;

export type LanguageDropdownUpdateMutation = {
  __typename?: "Mutation";
  setCurrentUserLanguage: {
    __typename?: "User";
    id: string;
    preferredLanguage: Language;
  };
};

export type UpdateMatchedHumanLanguageMutationVariables = Exact<{
  language: Language;
}>;

export type UpdateMatchedHumanLanguageMutation = {
  __typename?: "Mutation";
  updateMatchedHumanLanguage: { __typename?: "MatchedHuman"; id: number };
};

export const FullCalendarEventFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullCalendarEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FullCalendarEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedProps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FullCalendarEventFragment, unknown>;
export const HumanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanFragment, unknown>;
export const UseSelectTranslationStringInputFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UseSelectTranslationStringInputFragment, unknown>;
export const OrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationFragment, unknown>;
export const HumanWithOrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanWithOrganizationFragment, unknown>;
export const ClientForProfessionalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientForProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Client" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientForProfessionalFragment, unknown>;
export const RestrictedClientForProfessionalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RestrictedClientForProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RestrictedClient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RestrictedClientForProfessionalFragment, unknown>;
export const ClientFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Client" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Client" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canPayWithCredits" },
                },
                { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientFragment, unknown>;
export const CashTransactionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CashTransactionFragment, unknown>;
export const MessageFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MessageFragment, unknown>;
export const CommonConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CommonConsultationFragment, unknown>;
export const HumanForConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanForConsultationFragment, unknown>;
export const ProfessionalForConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalForConsultationFragment, unknown>;
export const ConsultationForCallFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationForCall" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsultationForCallFragment, unknown>;
export const ConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Consultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsultationFragment, unknown>;
export const ConsultationWithPaymentFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationWithPayment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsultationWithPaymentFragment, unknown>;
export const HumanRegistrationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanRegistration" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanRegistrationFragment, unknown>;
export const ProfessionalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Professional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "clientStop" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isFirstLine" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "roleType" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "supervision" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalFragment, unknown>;
export const AddressFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddressFragment, unknown>;
export const BillingInformationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BillingInformation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BillingInformation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountNumber" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BillingInformationFragment, unknown>;
export const PracticeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PracticeFragment, unknown>;
export const ProfessionalExtraFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalExtra" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cmNumber" } },
          { kind: "Field", name: { kind: "Name", value: "visumNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingInformation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BillingInformation" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Practice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BillingInformation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BillingInformation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountNumber" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalExtraFragment, unknown>;
export const ProfessionalFullFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Professional" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalExtra" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "licenseFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionName" },
                },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "mimeType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BillingInformation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BillingInformation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountNumber" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Professional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "clientStop" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isFirstLine" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "roleType" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "supervision" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalExtra" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cmNumber" } },
          { kind: "Field", name: { kind: "Name", value: "visumNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingInformation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BillingInformation" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Practice" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalFullFragment, unknown>;
export const ProfessionalInfoForHumanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalInfoForHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "availability" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Practice" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preferredLanguage" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalInfoForHumanFragment, unknown>;
export const QualityQuestionFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QualityQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Question" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "component" } },
          { kind: "Field", name: { kind: "Name", value: "nextQuestionId" } },
          { kind: "Field", name: { kind: "Name", value: "options" } },
          { kind: "Field", name: { kind: "Name", value: "questionType" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "translationKey" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<QualityQuestionFragment, unknown>;
export const ReimbursementInfoConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReimbursementInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ReimbursementInfoConsultationFragment, unknown>;
export const OrgProfileDialogOrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrgProfileDialogOrganizationFragment, unknown>;
export const ConsultationInfoConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ReimbursementInfoConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrgProfileDialogOrganization",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReimbursementInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsultationInfoConsultationFragment, unknown>;
export const ConsultationDetailConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationDetailConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ConsultationInfoConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReimbursementInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ReimbursementInfoConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrgProfileDialogOrganization",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ConsultationDetailConsultationFragment, unknown>;
export const RequestConsultationHumanInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RequestConsultationHumanInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayCoachingWithCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayConsultWithCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videoEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RequestConsultationHumanInfoFragment, unknown>;
export const BookingSidePanelConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BookingSidePanelConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RequestConsultationHumanInfo" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RequestConsultationHumanInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayCoachingWithCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayConsultWithCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videoEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BookingSidePanelConsultationFragment, unknown>;
export const ClientInfoSidePanelConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientInfoSidePanelConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrgProfileDialogOrganization",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preferredLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ClientInfoSidePanelConsultationFragment, unknown>;
export const ButtonBarConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ButtonBarConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "BookingSidePanelConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ClientInfoSidePanelConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RequestConsultationHumanInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayCoachingWithCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayConsultWithCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videoEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BookingSidePanelConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RequestConsultationHumanInfo" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientInfoSidePanelConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrgProfileDialogOrganization",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preferredLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ButtonBarConsultationFragment, unknown>;
export const StartCallPopupConsultationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StartCallPopupConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<StartCallPopupConsultationFragment, unknown>;
export const AvatarFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvatarFragment, unknown>;
export const ProfessionalListItemFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Avatar" },
                },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalListItemFragment, unknown>;
export const HumanMutualityFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanMutuality" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mutuality" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanMutualityFragment, unknown>;
export const CostSentenceHumanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditBalance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingCoachingConsultations",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingTherapyConsultations",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CostSentenceHumanFragment, unknown>;
export const CostSentenceOrganizationFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canCreditsBeUsed" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "forCoaching" } },
                { kind: "Field", name: { kind: "Name", value: "forTherapy" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CostSentenceOrganizationFragment, unknown>;
export const ProfCardMatchedHumanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfCardMatchedHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatchedHuman" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "treatment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CostSentenceHuman" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mutuality" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CostSentenceOrganization" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subtopic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditBalance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingCoachingConsultations",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingTherapyConsultations",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canCreditsBeUsed" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "forCoaching" } },
                { kind: "Field", name: { kind: "Name", value: "forTherapy" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfCardMatchedHumanFragment, unknown>;
export const CostSentenceProfessionalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CostSentenceProfessionalFragment, unknown>;
export const ProfCardProfFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfCardProf" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CostSentenceProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availabilityV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "amountOfDaysInTheFuture" },
                value: { kind: "IntValue", value: "31" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "consultationType" },
                value: { kind: "EnumValue", value: "INTRO" },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isOnline" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profileDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfCardProfFragment, unknown>;
export const OrganizationHeaderFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "pobosEnabled" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationHeaderFragment, unknown>;
export const OrganizationNavBarFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationNavBar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationNavBarFragment, unknown>;
export const OrganizationApproachFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationApproach" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "pobosEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OrganizationApproachFragment, unknown>;
export const ColleagueFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Colleague" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Avatar" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ColleagueFragment, unknown>;
export const ColleagueNodeFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ColleagueNode" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Colleague" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Colleague" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Avatar" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ColleagueNodeFragment, unknown>;
export const ViewOnlyProfessionalProfileFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewOnlyProfessionalProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postcode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profileDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewOnlyProfessionalProfileFragment, unknown>;
export const RateSelectFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RateSelect" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyEnabled" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RateSelectFragment, unknown>;
export const SubtopicFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Subtopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Subtopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "descriptionTranslationKey" },
          },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "titleTranslationKey" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubtopicFragment, unknown>;
export const SubtopicsOnProfessionalFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubtopicsOnProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Subtopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Subtopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "descriptionTranslationKey" },
          },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "titleTranslationKey" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubtopicsOnProfessionalFragment, unknown>;
export const AffiliatedMutualityHumanFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AffiliatedMutualityHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mutuality" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AffiliatedMutualityHumanFragment, unknown>;
export const ProfessionalConsultationListFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalConsultationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsultationsConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cashTransaction" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "human" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Avatar" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProfessionalConsultationListFragment, unknown>;
export const ViewOnlyProfileInfoFragmentDoc = {
  kind: "Document",
  definitions: [
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewOnlyProfileInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Avatar" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ViewOnlyProfileInfoFragment, unknown>;
export const ResetPasswordDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "resetPassword" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "resetPassword" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ResetPasswordMutation,
  ResetPasswordMutationVariables
>;
export const CreateFullCalendarEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createFullCalendarEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CalendarEventInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createCalendarEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FullCalendarEvent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullCalendarEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FullCalendarEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedProps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateFullCalendarEventMutation,
  CreateFullCalendarEventMutationVariables
>;
export const UpdateCalendarEventDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateCalendarEvent" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateCalendarEventInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateCalendarEvent" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FullCalendarEvent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullCalendarEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FullCalendarEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedProps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateCalendarEventMutation,
  UpdateCalendarEventMutationVariables
>;
export const CopyCalendarEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "copyCalendarEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CopyCalendarEventsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "copyCalendarEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FullCalendarEvent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullCalendarEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FullCalendarEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedProps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CopyCalendarEventsMutation,
  CopyCalendarEventsMutationVariables
>;
export const DeleteCalendarEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "deleteCalendarEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "DeleteCalendarEventsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "deleteCalendarEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteCalendarEventsMutation,
  DeleteCalendarEventsMutationVariables
>;
export const GetFullCalendarEventsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getFullCalendarEvents" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "endDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "startDate" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "DateTime" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "calendarEvents" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "asFullCalendar" },
                value: { kind: "BooleanValue", value: true },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "endDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "endDate" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "startDate" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "startDate" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "FullCalendarEvent" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "FullCalendarEvent" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "FullCalendarEvent" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "allDay" } },
          { kind: "Field", name: { kind: "Name", value: "end" } },
          { kind: "Field", name: { kind: "Name", value: "start" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "extendedProps" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetFullCalendarEventsQuery,
  GetFullCalendarEventsQueryVariables
>;
export const GetCashLastTransactionByConsultationIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getCashLastTransactionByConsultationId" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consultationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "lastCashTransactionByConsultationId",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "consultationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consultationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetCashLastTransactionByConsultationIdQuery,
  GetCashLastTransactionByConsultationIdQueryVariables
>;
export const InviteClientDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "inviteClient" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AddClientInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "inviteClient" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  InviteClientMutation,
  InviteClientMutationVariables
>;
export const AcceptInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "acceptInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AcceptInviteInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Client" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Client" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Client" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "canPayWithCredits" },
                },
                { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AcceptInviteMutation,
  AcceptInviteMutationVariables
>;
export const ClientsForProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "clientsForProfessional" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "clientsForProfessional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ClientForProfessional",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "RestrictedClientForProfessional",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientForProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Client" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RestrictedClientForProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "RestrictedClient" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "description" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientsForProfessionalQuery,
  ClientsForProfessionalQueryVariables
>;
export const CreateConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Consultation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Consultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateConsultationMutation,
  CreateConsultationMutationVariables
>;
export const ConsultationUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "consultationUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Consultation" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Consultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConsultationUpdateMutation,
  ConsultationUpdateMutationVariables
>;
export const ConfirmConsultationMutationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "confirmConsultationMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConfirmConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByHuman" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmConsultationMutationMutation,
  ConfirmConsultationMutationMutationVariables
>;
export const AllHumanConsultationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "allHumanConsultations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "allConsultationsForHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ConsultationWithPayment",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationWithPayment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllHumanConsultationsQuery,
  AllHumanConsultationsQueryVariables
>;
export const AllProfessionalConsultationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "allProfessionalConsultations" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "allConsultationsForProfessional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Consultation" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Consultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllProfessionalConsultationsQuery,
  AllProfessionalConsultationsQueryVariables
>;
export const ConsultationsForProfessionalAndHumanResolverDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {
        kind: "Name",
        value: "consultationsForProfessionalAndHumanResolver",
      },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "humanId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "consultationsForProfessionalAndHuman",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "humanId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "humanId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Consultation" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Consultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConsultationsForProfessionalAndHumanResolverQuery,
  ConsultationsForProfessionalAndHumanResolverQueryVariables
>;
export const FetchConsultationForCallByUuidDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchConsultationForCallByUuid" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ConsultationForCall" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanWithOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Human" } },
          { kind: "Field", name: { kind: "Name", value: "canPayWithCredits" } },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "humanId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanWithOrganization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationForCall" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "HumanForConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchConsultationForCallByUuidQuery,
  FetchConsultationForCallByUuidQueryVariables
>;
export const FetchConsultationWithCashTransactionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fetchConsultationWithCashTransaction" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ConsultationWithPayment" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CashTransaction" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "CashTransaction" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "amount" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Message" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Message" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "body" } },
          { kind: "Field", name: { kind: "Name", value: "fromProfessional" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CommonConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "acceptedByHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "acceptedByProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "requestedBy" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Message" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalForConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "professionalId" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "consultationLanguages" },
                },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                { kind: "Field", name: { kind: "Name", value: "profile" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationWithPayment" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CommonConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalForConsultation" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CashTransaction" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FetchConsultationWithCashTransactionQuery,
  FetchConsultationWithCashTransactionQueryVariables
>;
export const RegisterHumanWithInviteDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "registerHumanWithInvite" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RegisterHumanWithInviteInput" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "inviteToken" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerHumanWithInvite" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "inviteToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "inviteToken" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshToken" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "HumanRegistration" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanRegistration" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterHumanWithInviteMutation,
  RegisterHumanWithInviteMutationVariables
>;
export const UpdateHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateHuman" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateHumanInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateHuman" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Human" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateHumanMutation, UpdateHumanMutationVariables>;
export const HumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "human" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Human" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Human" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "organizationId" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanQuery, HumanQueryVariables>;
export const InitialDataDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "InitialData" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "isOrgAdmin" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
                { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
                { kind: "Field", name: { kind: "Name", value: "phone" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preferredLanguage" },
                },
                { kind: "Field", name: { kind: "Name", value: "timezone" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canPayWithCredits" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "avatar" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<InitialDataQuery, InitialDataQueryVariables>;
export const CreatePaymentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "createPayment" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "PaymentInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "payForConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreatePaymentMutation,
  CreatePaymentMutationVariables
>;
export const RegisterProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterProfessional" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProfessionalRegistrationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerProfessional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterProfessionalMutation,
  RegisterProfessionalMutationVariables
>;
export const UpdateProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "updateProfessional" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProfessionalInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfessional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfessionalFull" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Professional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "clientStop" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isFirstLine" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "roleType" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "supervision" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BillingInformation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BillingInformation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountNumber" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalExtra" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cmNumber" } },
          { kind: "Field", name: { kind: "Name", value: "visumNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingInformation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BillingInformation" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Practice" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalFull" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Professional" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ProfessionalExtra" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "licenseFiles" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "collectionName" },
                },
                { kind: "Field", name: { kind: "Name", value: "fileName" } },
                { kind: "Field", name: { kind: "Name", value: "mimeType" } },
                { kind: "Field", name: { kind: "Name", value: "name" } },
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProfessionalMutation,
  UpdateProfessionalMutationVariables
>;
export const FullProfessionalProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "fullProfessionalProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Professional" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfessionalExtra" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BillingInformation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "BillingInformation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "accountNumber" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "taxId" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Professional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "clientStop" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isFirstLine" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "roleType" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "supervision" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalExtra" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "cmNumber" } },
          { kind: "Field", name: { kind: "Name", value: "visumNumber" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "billingInformation" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "BillingInformation" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Practice" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  FullProfessionalProfileQuery,
  FullProfessionalProfileQueryVariables
>;
export const ProfessionalCurrentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "professionalCurrent" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Professional" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Professional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "clientStop" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isFirstLine" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "roleType" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "supervision" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          { kind: "Field", name: { kind: "Name", value: "verifiedAt" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalCurrentQuery,
  ProfessionalCurrentQueryVariables
>;
export const ProfessionalsForHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "professionalsForHuman" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NamedType",
            name: { kind: "Name", value: "ProfessionalsForCurrentHumanInput" },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professionalsForCurrentHuman" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ProfessionalInfoForHuman",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Address" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Address" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "country" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "location" } },
          { kind: "Field", name: { kind: "Name", value: "postcode" } },
          { kind: "Field", name: { kind: "Name", value: "street" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Practice" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Practice" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "chatTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "createdAt" } },
          { kind: "Field", name: { kind: "Name", value: "offlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "onlineTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "phoneTherapy" } },
          { kind: "Field", name: { kind: "Name", value: "updatedAt" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "address" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Address" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalInfoForHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "availability" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "onboardedAt" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "profile" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
          { kind: "Field", name: { kind: "Name", value: "training" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Practice" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preferredLanguage" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalsForHumanQuery,
  ProfessionalsForHumanQueryVariables
>;
export const ProfessionalExistsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "professionalExists" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "email" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professionalExists" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "email" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "email" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalExistsQuery,
  ProfessionalExistsQueryVariables
>;
export const GetQuestionByIdDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getQuestionById" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getQuestionById" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "QualityQuestion" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QualityQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Question" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "component" } },
          { kind: "Field", name: { kind: "Name", value: "nextQuestionId" } },
          { kind: "Field", name: { kind: "Name", value: "options" } },
          { kind: "Field", name: { kind: "Name", value: "questionType" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "translationKey" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetQuestionByIdQuery,
  GetQuestionByIdQueryVariables
>;
export const QuestionForUserAtEntryPointDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "questionForUserAtEntryPoint" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "EntryPointsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "questionForUserAtEntryPoint" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "QualityQuestion" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "QualityQuestion" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Question" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "category" } },
          { kind: "Field", name: { kind: "Name", value: "component" } },
          { kind: "Field", name: { kind: "Name", value: "nextQuestionId" } },
          { kind: "Field", name: { kind: "Name", value: "options" } },
          { kind: "Field", name: { kind: "Name", value: "questionType" } },
          { kind: "Field", name: { kind: "Name", value: "title" } },
          { kind: "Field", name: { kind: "Name", value: "translationKey" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  QuestionForUserAtEntryPointQuery,
  QuestionForUserAtEntryPointQueryVariables
>;
export const RefreshAccessTokenDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RefreshAccessToken" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "refreshToken" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "refreshAccessTokenV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "refreshToken" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "refreshToken" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshToken" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RefreshAccessTokenMutation,
  RefreshAccessTokenMutationVariables
>;
export const ConsultationDateSelectionAvailabilityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ConsultationDateSelectionAvailability" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consultationType" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConsultationType" },
            },
          },
        },
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "professionalId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "professionalId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "availabilityV2" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "amountOfDaysInTheFuture" },
                      value: { kind: "IntValue", value: "31" },
                    },
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "consultationType" },
                      value: {
                        kind: "Variable",
                        name: { kind: "Name", value: "consultationType" },
                      },
                    },
                  ],
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConsultationDateSelectionAvailabilityQuery,
  ConsultationDateSelectionAvailabilityQueryVariables
>;
export const ConsultationDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ConsultationDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consultationId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consultationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "ConsultationDetailConsultation",
                  },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "OrgProfileDialogOrganization",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "profile" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "useSelectTranslationStringInput",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ReimbursementInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "expectedReimbursementDate" },
          },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationInfoConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ReimbursementInfoConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "status" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrgProfileDialogOrganization",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "message" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "body" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "email" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ConsultationDetailConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ConsultationInfoConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConsultationDetailQuery,
  ConsultationDetailQueryVariables
>;
export const ReimbursementInfoMutualitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReimbursementInfoMutualities" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutualities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "preferred" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "preferred" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReimbursementInfoMutualitiesQuery,
  ReimbursementInfoMutualitiesQueryVariables
>;
export const HumanSidebarDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HumanSidebar" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isOrgAdmin" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "mindlabEnabled" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<HumanSidebarQuery, HumanSidebarQueryVariables>;
export const VideoCallConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "VideoCallConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ButtonBarConsultation" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "StartCallPopupConsultation" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RequestConsultationHumanInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayCoachingWithCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayConsultWithCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videoEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "BookingSidePanelConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RequestConsultationHumanInfo" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ClientInfoSidePanelConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "amount" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "OrgProfileDialogOrganization",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "preferredLanguage" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "timezone" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ButtonBarConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "BookingSidePanelConsultation" },
          },
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "ClientInfoSidePanelConsultation" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "StartCallPopupConsultation" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Consultation" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "scheduledFrom" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "uuid" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "cashTransaction" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditTransactions" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VideoCallConsultationQuery,
  VideoCallConsultationQueryVariables
>;
export const UserJoinedConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UserJoinedConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consultationId" },
          },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "userJoinedConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "consultationId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consultationId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UserJoinedConsultationMutation,
  UserJoinedConsultationMutationVariables
>;
export const StartVideoCallV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartVideoCallV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consultationUuid" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startVideoCallV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "consultationUuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consultationUuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "attendeeInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "AttendeeId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ExternalUserId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "JoinToken" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "meetingInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ExternalMeetingId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "MediaRegion" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "MeetingId" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "MediaPlacement" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "AudioFallbackUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "AudioHostUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ScreenDataUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ScreenSharingUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "ScreenViewingUrl" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "SignalingUrl" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartVideoCallV2Mutation,
  StartVideoCallV2MutationVariables
>;
export const ChoosePasswordV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ChoosePasswordV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ChoosePasswordV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "choosePasswordV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ChoosePasswordV2Mutation,
  ChoosePasswordV2MutationVariables
>;
export const ConfirmConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConfirmConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByHuman" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmConsultationMutation,
  ConfirmConsultationMutationVariables
>;
export const ProfessionalsForHumanOverviewDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfessionalsForHumanOverview" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "ProfessionalsForCurrentHumanInput",
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professionalsForCurrentHuman" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ProfessionalListItem",
                              },
                            },
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "ViewOnlyProfessionalProfile",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "ViewOnlyProfileInfo",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalListItem" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Avatar" },
                },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewOnlyProfessionalProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postcode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profileDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewOnlyProfileInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Avatar" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalsForHumanOverviewQuery,
  ProfessionalsForHumanOverviewQueryVariables
>;
export const HumanProfilePageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "HumanProfilePage" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "HumanMutuality" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditBalance" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "total" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "HumanMutuality" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mutuality" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  HumanProfilePageQuery,
  HumanProfilePageQueryVariables
>;
export const MutualitySelectDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "MutualitySelect" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mutualityId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateHumanMutuality" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "mutualityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "mutualityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MutualitySelectMutation,
  MutualitySelectMutationVariables
>;
export const SelectMutualitesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SelectMutualites" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutualities" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SelectMutualitesQuery,
  SelectMutualitesQueryVariables
>;
export const CompleteHumanRegistrationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "CompleteHumanRegistration" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CompleteHumanRegistrationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "completeHumanRegistration" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "firstName" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "lastName" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "phone" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CompleteHumanRegistrationMutation,
  CompleteHumanRegistrationMutationVariables
>;
export const RequestConsultationFormUserDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RequestConsultationFormUser" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "CostSentenceHuman" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mutuality" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "CostSentenceOrganization",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "coachingEnabled" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "videoEnabled" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditBalance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingCoachingConsultations",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingTherapyConsultations",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canCreditsBeUsed" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "forCoaching" } },
                { kind: "Field", name: { kind: "Name", value: "forTherapy" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestConsultationFormUserQuery,
  RequestConsultationFormUserQueryVariables
>;
export const RequestConsultationFormProfDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RequestConsultationFormProf" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "professionalId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "professionalId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CostSentenceProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "therapyEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestConsultationFormProfQuery,
  RequestConsultationFormProfQueryVariables
>;
export const LoginDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "Login" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LoginV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "loginV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "TokenResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessToken" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "refreshToken" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LoginV2FailureResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const SsoUrlDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "SsoUrl" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "redirectUrl" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "getSSOUrl" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "redirectUrl" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "redirectUrl" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SsoUrlQuery, SsoUrlQueryVariables>;
export const LoginWithSsoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LoginWithSso" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LoginWithSSOInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "loginWithSSO" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "TokenResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessToken" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mindlabToken" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "refreshToken" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LoginWithSsoMutation,
  LoginWithSsoMutationVariables
>;
export const ProposedMatchesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProposedMatches" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfCardMatchedHuman" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "proposedMatches" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ProfCardProf" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtopic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditBalance" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingCoachingConsultations",
                  },
                },
                {
                  kind: "Field",
                  name: {
                    kind: "Name",
                    value: "remainingTherapyConsultations",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canCreditsBeUsed" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "forCoaching" } },
                { kind: "Field", name: { kind: "Name", value: "forTherapy" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "CostSentenceProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfCardMatchedHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MatchedHuman" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "treatment" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "human" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CostSentenceHuman" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "mutuality" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "CostSentenceOrganization" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subtopic" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfCardProf" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "CostSentenceProfessional" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "availabilityV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "amountOfDaysInTheFuture" },
                value: { kind: "IntValue", value: "31" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "consultationType" },
                value: { kind: "EnumValue", value: "INTRO" },
              },
            ],
          },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "gender" } },
          { kind: "Field", name: { kind: "Name", value: "isOnline" } },
          { kind: "Field", name: { kind: "Name", value: "type" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "avatar" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "url" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profileDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProposedMatchesQuery,
  ProposedMatchesQueryVariables
>;
export const MatchConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MatchConsultation" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchConsultation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledFrom" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "type" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "professional" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "avatar" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "url" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtopic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MatchConsultationQuery,
  MatchConsultationQueryVariables
>;
export const CountriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Countries" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "countries" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                { kind: "Field", name: { kind: "Name", value: "imgUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "regions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "descriptionTranslationKey",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imgUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountriesQuery, CountriesQueryVariables>;
export const LocationStepMatchedHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "LocationStepMatchedHuman" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noLocation" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "country" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "region" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LocationStepMatchedHumanQuery,
  LocationStepMatchedHumanQueryVariables
>;
export const SubmitLocationStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitLocationStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "SubmitLocationStepInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitLocationStep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchingToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "nextStep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchedHuman" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noLocation" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "country" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mutualityOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "otherMutualities" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "regionMutualities",
                              },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "region" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitLocationStepMutation,
  SubmitLocationStepMutationVariables
>;
export const RequestIntroConsultDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestIntroConsult" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RequestIntroAsHumanInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestIntroAsHuman" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "isInstant" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledFrom" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "avatar" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestIntroConsultMutation,
  RequestIntroConsultMutationVariables
>;
export const MutualitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Mutualities" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noMutuality" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutualityOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "otherMutualities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "descriptionTranslationKey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imgUrl" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linkUrlTranslationKey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "preferred" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "regionMutualities" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "descriptionTranslationKey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imgUrl" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "linkUrlTranslationKey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "preferred" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "consultsPerHuman" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "videoEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MutualitiesQuery, MutualitiesQueryVariables>;
export const SubmitMutualityStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitMutualityStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mutualityId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitMutualityStep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "mutualityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "mutualityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchingToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "nextStep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchedHuman" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noMutuality" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mutuality" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitMutualityStepMutation,
  SubmitMutualityStepMutationVariables
>;
export const StartMatchingV2Document = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "StartMatchingV2" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "StartMatchingV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "startMatchingV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchingToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "nextStep" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartMatchingV2Mutation,
  StartMatchingV2MutationVariables
>;
export const LoginInMatchingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LoginInMatching" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "LoginV2Input" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "loginV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "TokenResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "accessToken" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "refreshToken" },
                      },
                    ],
                  },
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: { kind: "Name", value: "LoginV2FailureResponse" },
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "reason" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LoginInMatchingMutation,
  LoginInMatchingMutationVariables
>;
export const RegisterInMatchingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RegisterInMatching" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RegisterHumanInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "registerHumanV2" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "accessToken" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "refreshToken" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RegisterInMatchingMutation,
  RegisterInMatchingMutationVariables
>;
export const SubtopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Subtopics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noSubtopic" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtopic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "descriptionTranslationKey",
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "imageUrl" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subtopics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "descriptionTranslationKey",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "imageUrl" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "titleTranslationKey",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubtopicsQuery, SubtopicsQueryVariables>;
export const SubmitSubtopicStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitSubtopicStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "subtopicId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitSubtopicStep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "subtopicId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "subtopicId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchingToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "nextStep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchedHuman" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noSubtopic" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subtopic" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treatmentOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "availableTreatments",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "proposedTreatment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "module" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitSubtopicStepMutation,
  SubmitSubtopicStepMutationVariables
>;
export const TopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Topics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "topics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TopicsQuery, TopicsQueryVariables>;
export const TopicStepMatchedHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "TopicStepMatchedHuman" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "noTopic" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "topic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TopicStepMatchedHumanQuery,
  TopicStepMatchedHumanQueryVariables
>;
export const SubmitTopicStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitTopicStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "topicId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitTopicStep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "topicId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "topicId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchingToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "nextStep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchedHuman" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "noTopic" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topic" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treatmentOptions" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "availableTreatments",
                              },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "proposedTreatment",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "module" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitTopicStepMutation,
  SubmitTopicStepMutationVariables
>;
export const TreatmentsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Treatments" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "organization" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "code" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mindlabEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "ssoEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "name" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "treatmentOptions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "availableTreatments" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "proposedTreatment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "module" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "url" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "useSelectTranslationStringInput",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TreatmentsQuery, TreatmentsQueryVariables>;
export const SubmitTreatmentStepDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "SubmitTreatmentStep" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "treatment" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Treatment" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "submitTreatmentStep" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "treatment" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "treatment" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchingToken" },
                },
                { kind: "Field", name: { kind: "Name", value: "nextStep" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchedHuman" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treatment" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubmitTreatmentStepMutation,
  SubmitTreatmentStepMutationVariables
>;
export const WaitingRoomDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "WaitingRoom" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentMatchedHuman" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchConsultation" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "professional" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "availabilityV2" },
                              arguments: [
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "amountOfDaysInTheFuture",
                                  },
                                  value: { kind: "IntValue", value: "31" },
                                },
                                {
                                  kind: "Argument",
                                  name: {
                                    kind: "Name",
                                    value: "consultationType",
                                  },
                                  value: { kind: "EnumValue", value: "INTRO" },
                                },
                              ],
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "subtopic" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WaitingRoomQuery, WaitingRoomQueryVariables>;
export const WaitingRoomCancelConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "WaitingRoomCancelConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CancelConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  WaitingRoomCancelConsultationMutation,
  WaitingRoomCancelConsultationMutationVariables
>;
export const DashboardsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "Dashboards" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "adminOrganizations" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "videoEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "contractDashboardUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "interestDashboardUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "mentalWellbeingDashboardUrl",
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "usageDashboardUrl" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "useSelectTranslationStringInput",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardsQuery, DashboardsQueryVariables>;
export const VerifyOrganizationPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "VerifyOrganizationPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emailOrCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationByEmailOrCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailOrCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emailOrCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  VerifyOrganizationPageQuery,
  VerifyOrganizationPageQueryVariables
>;
export const OrganisationLandingPageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OrganisationLandingPage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "emailOrCode" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "organizationByEmailOrCode" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "emailOrCode" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "emailOrCode" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Organization" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrganizationApproach" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrganizationHeader" },
                },
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "OrganizationNavBar" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Organization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "color" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "slug" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationApproach" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "code" } },
          { kind: "Field", name: { kind: "Name", value: "consultsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabBusinessId" } },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "pobosEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationHeader" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "pobosEnabled" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrganizationNavBar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "ssoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "logoUrl" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OrganisationLandingPageQuery,
  OrganisationLandingPageQueryVariables
>;
export const ColleagueDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "colleague" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ViewOnlyProfessionalProfile" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "user" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "ViewOnlyProfileInfo" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewOnlyProfessionalProfile" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "consultationLanguages" },
          },
          { kind: "Field", name: { kind: "Name", value: "experienceSince" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          { kind: "Field", name: { kind: "Name", value: "website" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "practice" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "address" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "postcode" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "street" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profileDescription" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "descriptionTranslationKey" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ViewOnlyProfileInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "FragmentSpread", name: { kind: "Name", value: "Avatar" } },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "birthDate" } },
          { kind: "Field", name: { kind: "Name", value: "email" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          { kind: "Field", name: { kind: "Name", value: "phone" } },
          { kind: "Field", name: { kind: "Name", value: "preferredLanguage" } },
          { kind: "Field", name: { kind: "Name", value: "timezone" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ColleagueQuery, ColleagueQueryVariables>;
export const ColleaguesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "colleagues" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ProfessionalsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professionals" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "totalCount" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "node" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "ColleagueNode" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Colleague" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "therapyTypes" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "user" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Avatar" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "firstName" } },
                { kind: "Field", name: { kind: "Name", value: "lastName" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ColleagueNode" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: { kind: "Name", value: "Colleague" },
          },
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ColleaguesQuery, ColleaguesQueryVariables>;
export const ProfessionalRateOnboardingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfessionalRateOnboarding" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "coachingEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "coachingRate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "standardRate" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "therapyEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalRateOnboardingQuery,
  ProfessionalRateOnboardingQueryVariables
>;
export const UpdateProfessionalRateOnboardingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProfessionalRateOnboarding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateProfessionalRateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfessionalRate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "therapyEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProfessionalRateOnboardingMutation,
  UpdateProfessionalRateOnboardingMutationVariables
>;
export const ToggleCoachingOnboardingDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleCoachingOnboarding" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toggleCoachingEnabledForProfessional",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleCoachingOnboardingMutation,
  ToggleCoachingOnboardingMutationVariables
>;
export const OnboardingSubtopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "OnboardingSubtopics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "primarySubtopics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "titleTranslationKey",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "secondarySubtopics" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "titleTranslationKey",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "subtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "titleTranslationKey" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnboardingSubtopicsQuery,
  OnboardingSubtopicsQueryVariables
>;
export const OnboardProfessionalSubtopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "OnboardProfessionalSubtopics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateProfessionalSubtopicsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfessionalSubtopics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "primarySubtopics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "secondarySubtopics" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "titleTranslationKey" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  OnboardProfessionalSubtopicsMutation,
  OnboardProfessionalSubtopicsMutationVariables
>;
export const ProfessionalProfileDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfessionalProfile" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: { kind: "Name", value: "RateSelect" },
                      },
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "SubtopicsOnProfessional",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "coachingEnabled" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "therapyEnabled" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Subtopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Subtopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "descriptionTranslationKey" },
          },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "titleTranslationKey" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RateSelect" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyEnabled" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubtopicsOnProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalProfileQuery,
  ProfessionalProfileQueryVariables
>;
export const ToggleCoachingEnabledForProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleCoachingEnabledForProfessional" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toggleCoachingEnabledForProfessional",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleCoachingEnabledForProfessionalMutation,
  ToggleCoachingEnabledForProfessionalMutationVariables
>;
export const ToggleTherapyEnabledForProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ToggleTherapyEnabledForProfessional" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Boolean" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {
              kind: "Name",
              value: "toggleTherapyEnabledForProfessional",
            },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "therapyEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ToggleTherapyEnabledForProfessionalMutation,
  ToggleTherapyEnabledForProfessionalMutationVariables
>;
export const UpdateProfessionalRateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProfessionalRate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateProfessionalRateInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfessionalRate" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "RateSelect" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RateSelect" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "coachingRate" } },
          { kind: "Field", name: { kind: "Name", value: "standardRate" } },
          { kind: "Field", name: { kind: "Name", value: "therapyEnabled" } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProfessionalRateMutation,
  UpdateProfessionalRateMutationVariables
>;
export const AllSubtopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "AllSubtopics" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "subtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Subtopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Subtopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "descriptionTranslationKey" },
          },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "titleTranslationKey" },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllSubtopicsQuery, AllSubtopicsQueryVariables>;
export const UpdateProfessionalSubtopicsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateProfessionalSubtopics" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "UpdateProfessionalSubtopicsInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateProfessionalSubtopics" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "SubtopicsOnProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Subtopic" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Subtopic" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "descriptionTranslationKey" },
          },
          { kind: "Field", name: { kind: "Name", value: "imageUrl" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "titleTranslationKey" },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "SubtopicsOnProfessional" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Professional" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "primarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "secondarySubtopics" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "Subtopic" },
                },
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateProfessionalSubtopicsMutation,
  UpdateProfessionalSubtopicsMutationVariables
>;
export const MollieRedirectHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "MollieRedirectHuman" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mutuality" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MollieRedirectHumanQuery,
  MollieRedirectHumanQueryVariables
>;
export const PaymentPageHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PaymentPageHuman" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "consultationUuid" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "consultationUuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cashTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: { kind: "Name", value: "Avatar" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "FragmentSpread",
                        name: {
                          kind: "Name",
                          value: "AffiliatedMutualityHuman",
                        },
                      },
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "AffiliatedMutualityHuman" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "mutuality" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PaymentPageHumanQuery,
  PaymentPageHumanQueryVariables
>;
export const ReimbursementPageHumanDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ReimbursementPageHuman" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "mutuality" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "title" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReimbursementPageHumanQuery,
  ReimbursementPageHumanQueryVariables
>;
export const UpdateHumanMutualityOnReimbursementInfoDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateHumanMutualityOnReimbursementInfo" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mutualityId" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateHumanMutuality" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "mutualityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "mutualityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "title" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHumanMutualityOnReimbursementInfoMutation,
  UpdateHumanMutualityOnReimbursementInfoMutationVariables
>;
export const RequestReimbursementDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "RequestReimbursement" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ReimbursementInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "requestReimbursement" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestReimbursementMutation,
  RequestReimbursementMutationVariables
>;
export const PaymentMutualitiesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "PaymentMutualities" },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "mutualities" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "preferred" },
                      value: { kind: "BooleanValue", value: true },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "preferred" } },
                { kind: "Field", name: { kind: "Name", value: "title" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PaymentMutualitiesQuery,
  PaymentMutualitiesQueryVariables
>;
export const UpdateHumanMutualityDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateHumanMutuality" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "mutualityId" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateHumanMutuality" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "mutualityId" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "mutualityId" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "mutuality" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateHumanMutualityMutation,
  UpdateHumanMutualityMutationVariables
>;
export const ClientConsultationDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ClientConsultationDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByHuman" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "bloomupFee" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professionalFee" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cashTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditTransactions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canPayWithCredits" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditsLeft" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "OrgProfileDialogOrganization",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "useSelectTranslationStringInput",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "user" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "email" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "firstName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "lastName" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "phone" },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "matchedHuman" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "treatment" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "subtopic" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "titleTranslationKey",
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "topic" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: {
                                kind: "Name",
                                value: "titleTranslationKey",
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "message" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ClientConsultationDetailQuery,
  ClientConsultationDetailQueryVariables
>;
export const ProfessionalCancelConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfessionalCancelConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalCancelConsultationQuery,
  ProfessionalCancelConsultationQueryVariables
>;
export const ProfessionalCancelConsultationMutationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProfessionalCancelConsultationMutation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CancelConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "cancelConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "message" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalCancelConsultationMutationMutation,
  ProfessionalCancelConsultationMutationMutationVariables
>;
export const ConsultationDetailActionsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ConsultationDetailActions" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByHuman" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "organization" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "FragmentSpread",
                              name: {
                                kind: "Name",
                                value: "OrgProfileDialogOrganization",
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "name" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "useSelectTranslationStringInput",
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "profile" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "useSelectTranslationStringInput",
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "email" } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "useSelectTranslationStringInput" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "MultiLanguageString" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "en" } },
          { kind: "Field", name: { kind: "Name", value: "fr" } },
          { kind: "Field", name: { kind: "Name", value: "nl" } },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "OrgProfileDialogOrganization" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Organization" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "coachingEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "contractEndDate" } },
          { kind: "Field", name: { kind: "Name", value: "contractStartDate" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "creditsPerCoaching" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsPerConsult" } },
          { kind: "Field", name: { kind: "Name", value: "creditsPerHuman" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "hasRenewalContract" },
          },
          { kind: "Field", name: { kind: "Name", value: "mindlabEnabled" } },
          { kind: "Field", name: { kind: "Name", value: "videoEnabled" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "name" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "profile" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: {
                    kind: "Name",
                    value: "useSelectTranslationStringInput",
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConsultationDetailActionsQuery,
  ConsultationDetailActionsQueryVariables
>;
export const ConfirmConsultationMutationProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ConfirmConsultationMutationProfessional" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "ConfirmConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "confirmConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByHuman" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "status" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ConfirmConsultationMutationProfessionalMutation,
  ConfirmConsultationMutationProfessionalMutationVariables
>;
export const RequestConsultationProfessionalDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RequestConsultationProfessional" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "standardRate" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "therapyEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestConsultationProfessionalQuery,
  RequestConsultationProfessionalQueryVariables
>;
export const RequestConsultationClientsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RequestConsultationClients" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "id" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "Int" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "id" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "id" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "clients" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "edges" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "node" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: {
                                      kind: "Name",
                                      value: "RequestConsultationHumanInfo",
                                    },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "user" },
                                    selectionSet: {
                                      kind: "SelectionSet",
                                      selections: [
                                        {
                                          kind: "Field",
                                          name: { kind: "Name", value: "id" },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "email",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "firstName",
                                          },
                                        },
                                        {
                                          kind: "Field",
                                          name: {
                                            kind: "Name",
                                            value: "lastName",
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "RequestConsultationHumanInfo" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "Human" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayCoachingWithCredits" },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "canPayConsultWithCredits" },
          },
          { kind: "Field", name: { kind: "Name", value: "creditsLeft" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "organization" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "coachingEnabled" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "videoEnabled" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RequestConsultationClientsQuery,
  RequestConsultationClientsQueryVariables
>;
export const ProfessionalRequestConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProfessionalRequestConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "CreateConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "createConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "uuid" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalRequestConsultationMutation,
  ProfessionalRequestConsultationMutationVariables
>;
export const RescheduleConsultationDetailDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "RescheduleConsultationDetail" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "uuid" } },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "String" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "consultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "uuid" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "uuid" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
                { kind: "Field", name: { kind: "Name", value: "type" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cashTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "creditTransactions" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "human" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "canPayWithCredits" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "creditsLeft" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RescheduleConsultationDetailQuery,
  RescheduleConsultationDetailQueryVariables
>;
export const ProfessionalRescheduleConsultationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "ProfessionalRescheduleConsultation" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "RescheduleConsultationInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "rescheduleConsultation" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "acceptedByProfessional" },
                },
                { kind: "Field", name: { kind: "Name", value: "duration" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "scheduledFrom" },
                },
                { kind: "Field", name: { kind: "Name", value: "scheduledTo" } },
                { kind: "Field", name: { kind: "Name", value: "status" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "cashTransaction" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "amount" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "message" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      { kind: "Field", name: { kind: "Name", value: "body" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalRescheduleConsultationMutation,
  ProfessionalRescheduleConsultationMutationVariables
>;
export const ProfessionalCompletedConsultationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfessionalCompletedConsultations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            name: { kind: "Name", value: "myProfessionalConsultations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "after" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "DONE" },
                          { kind: "EnumValue", value: "CANCELLED" },
                          { kind: "EnumValue", value: "CANCELLED_BY_HUMAN" },
                          {
                            kind: "EnumValue",
                            value: "CANCELLED_BY_PROFESSIONAL",
                          },
                          { kind: "EnumValue", value: "NO_SHOW_HUMAN" },
                          { kind: "EnumValue", value: "NO_SHOW_PROFESSIONAL" },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "20" },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfessionalConsultationList" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cursor" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endCursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasNextPage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalConsultationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsultationsConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cashTransaction" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "human" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Avatar" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalCompletedConsultationsQuery,
  ProfessionalCompletedConsultationsQueryVariables
>;
export const ProfessionalConsultationsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "ProfessionalConsultations" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "after" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "String" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "currentUser" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "professional" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "PlannedConsultations" },
            name: { kind: "Name", value: "myProfessionalConsultations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "after" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "after" },
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [
                          { kind: "EnumValue", value: "ACCEPTED" },
                          { kind: "EnumValue", value: "IN_PROGRESS" },
                          { kind: "EnumValue", value: "WAITING" },
                        ],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "20" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "scheduledFrom" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfessionalConsultationList" },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "edges" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cursor" },
                      },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "pageInfo" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "endCursor" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "hasNextPage" },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: "Field",
            alias: { kind: "Name", value: "RequestedConsultations" },
            name: { kind: "Name", value: "myProfessionalConsultations" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "filter" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "status" },
                      value: {
                        kind: "ListValue",
                        values: [{ kind: "EnumValue", value: "REQUESTED" }],
                      },
                    },
                  ],
                },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "first" },
                value: { kind: "IntValue", value: "200" },
              },
              {
                kind: "Argument",
                name: { kind: "Name", value: "order" },
                value: {
                  kind: "ObjectValue",
                  fields: [
                    {
                      kind: "ObjectField",
                      name: { kind: "Name", value: "scheduledFrom" },
                      value: { kind: "EnumValue", value: "asc" },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "FragmentSpread",
                  name: { kind: "Name", value: "ProfessionalConsultationList" },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "Avatar" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "User" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          { kind: "Field", name: { kind: "Name", value: "id" } },
          { kind: "Field", name: { kind: "Name", value: "firstName" } },
          { kind: "Field", name: { kind: "Name", value: "lastName" } },
          {
            kind: "Field",
            name: { kind: "Name", value: "professional" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "gender" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "avatar" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "url" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: "FragmentDefinition",
      name: { kind: "Name", value: "ProfessionalConsultationList" },
      typeCondition: {
        kind: "NamedType",
        name: { kind: "Name", value: "ConsultationsConnection" },
      },
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "edges" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {
                  kind: "Field",
                  name: { kind: "Name", value: "node" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "id" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "requestedBy" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "scheduledFrom" },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "status" },
                      },
                      { kind: "Field", name: { kind: "Name", value: "uuid" } },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "cashTransaction" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "status" },
                            },
                          ],
                        },
                      },
                      {
                        kind: "Field",
                        name: { kind: "Name", value: "human" },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "id" },
                            },
                            {
                              kind: "Field",
                              name: { kind: "Name", value: "user" },
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {
                                    kind: "FragmentSpread",
                                    name: { kind: "Name", value: "Avatar" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "id" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "email" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "firstName" },
                                  },
                                  {
                                    kind: "Field",
                                    name: { kind: "Name", value: "lastName" },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ProfessionalConsultationsQuery,
  ProfessionalConsultationsQueryVariables
>;
export const AnswerQuestionDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "AnswerQuestion" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "input" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "AnswerInput" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "answerQuestion" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "input" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "input" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AnswerQuestionMutation,
  AnswerQuestionMutationVariables
>;
export const LanguageDropdownUpdateDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "LanguageDropdownUpdate" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "language" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Language" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "setCurrentUserLanguage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "language" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "preferredLanguage" },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LanguageDropdownUpdateMutation,
  LanguageDropdownUpdateMutationVariables
>;
export const UpdateMatchedHumanLanguageDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: { kind: "Name", value: "UpdateMatchedHumanLanguage" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "language" },
          },
          type: {
            kind: "NonNullType",
            type: {
              kind: "NamedType",
              name: { kind: "Name", value: "Language" },
            },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "updateMatchedHumanLanguage" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "language" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "language" },
                },
              },
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateMatchedHumanLanguageMutation,
  UpdateMatchedHumanLanguageMutationVariables
>;
